/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-ts 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, RequestConfig, RequestFunctionRestArgs, FileData, prepare } from '@bigo/yapi-to-ts'
// @ts-ignore
import request from './request';
// @ts-ignore
import makeRequestHook from './makeRequestHook';

// makeRequest
function makeRequest<TReqeustData, TResponseData>(requestConfig) {
  const req = function (
    requestData?: TReqeustData,
    ...args: RequestFunctionRestArgs<typeof request>
  ) {
    return request<TResponseData>(prepare(requestConfig, requestData));
  };
  req.requestConfig = requestConfig;
  return req;
}

const mockUrl_2_0_0_0 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_0 = 'data' as any;

export interface Config3957Request {}

export interface Config3957Response {
  defaultMonth: string;
  country: string;
  defaultDate: string;
  showMultiRoom: boolean;
  regionShortName: string;
  singleShowField: string[];
  isWeeklyPaid: number;
  currentWeekMonday: string;
  currentWeekSunday: string;
  uid: number;
  multiShowField: string[];
  showOrder: string[];
  startTime: number;
  endTime: number;
  lastIsWeeklyPaid: number;
  newAnchorConfig: {
    access: boolean;
    stepRangeMap: {
      '1': {
        begin: string;
        end: string;
      };
      '2': {
        begin: string;
        end: string;
      };
      '3': {
        begin: string;
        end: string;
      };
    };
    signDate: string;
    liveDate: string;
    currentStep: number;
    inLastDisplayTime: boolean;
    whichDay: number;
    showFields: string[];
    jetLag: number;
    finishShowDayCount: number;
  };
}
type Config3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/config',
    'data',
    string,
    string,
    true
  >
>;

const config3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/config',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'config3957',
};

export const config3957 = makeRequest<Config3957Request, Config3957Response>(
  config3957RequestConfig,
);
export const useConfig3957 = makeRequestHook<
  Config3957Request,
  Config3957RequestConfig,
  ReturnType<typeof config3957>
>(config3957);

export interface ReportDay3957Request {
  from: string;
  to: string;
  /**
   * 默认为day
   */
  type?: string;
}

export interface ReportDay3957Response {
  uid: number;
  baseData: {
    sbean: {
      id: string;
      num: number;
      rate: number;
    };
    acu: {
      id: string;
      num: number;
      rate: number;
    };
    pcu: {
      id: string;
      num: number;
      rate: number;
    };
    payuser: {
      id: string;
      num: number;
      rate: number;
    };
    sfans: {
      id: string;
      num: number;
      rate: number;
    };
    prelostuser: {
      id: string;
      num: number;
      rate: number;
    };
    stime: {
      id: string;
      num: number;
      rate: number;
    };
    onelink: {
      id: string;
      num: number;
      rate: number;
    };
    sday: {
      id: string;
      num: number;
      rate: number;
    };
  };
  fieldsAndDay: {
    anchorViewerReportFields: string[];
    anchorViewerReportLatest: string;
    signOnlinkFields: string[];
    salaryInOutNobBeanFields: string[];
    signSalaryDataSummaryFields: [];
    anchorOverseaSupportFields: string[];
    signSalaryDataSummaryLatest: string;
  };
}
type ReportDay3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/reportDay',
    'data',
    string,
    string,
    false
  >
>;

const reportDay3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/reportDay',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'reportDay3957',
};

export const reportDay3957 = makeRequest<ReportDay3957Request, ReportDay3957Response>(
  reportDay3957RequestConfig,
);
export const useReportDay3957 = makeRequestHook<
  ReportDay3957Request,
  ReportDay3957RequestConfig,
  ReturnType<typeof reportDay3957>
>(reportDay3957);

export interface ReportMonth3957Request {
  month: string;
}

export interface ReportMonth3957Response {
  phase: number;
  uid: number;
  baseData: {
    in_beans: {
      id: string;
      num: number;
      rate: number;
    };
    sbean: {
      id: string;
      num: number;
      rate: number;
    };
    pack_gift_bean: {
      id: string;
      num: number;
      rate: number;
    };
    acu: {
      id: string;
      num: number;
      rate: number;
    };
    pcu: {
      id: string;
      num: number;
      rate: number;
    };
    payuser: {
      id: string;
      num: number;
      rate: number;
    };
    support_percent: {
      id: string;
      num: number;
      rate: number;
    };
    sfans: {
      id: string;
      num: number;
      rate: number;
    };
    prelostuser: {
      id: string;
      num: number;
      rate: number;
    };
    stime: {
      id: string;
      num: number;
      rate: number;
    };
    out_beans: {
      id: string;
      num: number;
      rate: number;
    };
    sday: {
      id: string;
      num: number;
      rate: number;
    };
    inOutBeanSum: {
      id: string;
      num: number;
      rate: number;
    };
    onelink_ios: {
      id: string;
      num: number;
      rate: number;
    };
    onelink_android: {
      id: string;
      num: number;
      rate: number;
    };
  };
  fieldsAndDay: {
    anchorViewerReportFields: string[];
    anchorViewerReportLatest: string;
    signOnlinkFields: string[];
    salaryInOutNobBeanLatest: string;
    salaryInOutNobBeanFields: string[];
    unRealTimeFields: string[];
    signSalaryDataSummaryFields: [];
    anchorOverseaSupportFields: string[];
    signSalaryDataSummaryLatest: string;
    anchorOverseaSupportLatest: string;
  };
  finish: {
    type: string;
    curVal: number;
    condition: [] | [number];
  }[];
  finishTotal: number;
  finishNum: number;
}
type ReportMonth3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/reportMonth',
    'data',
    string,
    string,
    false
  >
>;

const reportMonth3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/reportMonth',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'reportMonth3957',
};

export const reportMonth3957 = makeRequest<ReportMonth3957Request, ReportMonth3957Response>(
  reportMonth3957RequestConfig,
);
export const useReportMonth3957 = makeRequestHook<
  ReportMonth3957Request,
  ReportMonth3957RequestConfig,
  ReturnType<typeof reportMonth3957>
>(reportMonth3957);

export interface GraphData3957Request {
  /**
   * 查询类型，'sbean', 'sday', 'stime', 'sfans','pcu', 'acu', 'support_percent', 'out_region_percent','onelink','inOutBeanSum'
   */
  type: string;
  from: string;
  to: string;
  month: string;
  /**
   * 是否为周数据，1为是，0为否
   */
  week: string;
}

export interface GraphData3957Response {
  uid: number;
  type: string;
  list: {
    month: string;
    value: number;
  }[];
}
type GraphData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/graphData',
    'data',
    string,
    string,
    false
  >
>;

const graphData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/graphData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'graphData3957',
};

export const graphData3957 = makeRequest<GraphData3957Request, GraphData3957Response>(
  graphData3957RequestConfig,
);
export const useGraphData3957 = makeRequestHook<
  GraphData3957Request,
  GraphData3957RequestConfig,
  ReturnType<typeof graphData3957>
>(graphData3957);

export interface ExportUrl3957Request {
  from: string;
  to: string;
  month: string;
  /**
   * 是否为周，1为是0为否
   */
  week: string;
  /**
   * bigolive 60 funkie 72
   */
  appId: string;
}

export interface ExportUrl3957Response {
  urll: string;
  url: string;
}
type ExportUrl3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/exportUrl',
    'data',
    string,
    string,
    false
  >
>;

const exportUrl3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/exportUrl',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'exportUrl3957',
};

export const exportUrl3957 = makeRequest<ExportUrl3957Request, ExportUrl3957Response>(
  exportUrl3957RequestConfig,
);
export const useExportUrl3957 = makeRequestHook<
  ExportUrl3957Request,
  ExportUrl3957RequestConfig,
  ReturnType<typeof exportUrl3957>
>(exportUrl3957);

export interface PreLostUserGetUserList3957Request {
  /**
   * 1
   */
  dataType: number;
  /**
   * "2022-08-22"
   */
  day: string;
  /**
   * 1
   */
  pageIndex: number;
  /**
   * 20
   */
  pageSize: number;
  /**
   * "1.20.1"
   */
  version: string;
}

export interface PreLostUserGetUserList3957Response {
  pageSize: number;
  pageIndex: number;
  total: number;
  todaySendCount: number;
  userList: {
    uid: number;
    avatar: string;
    nickName: string;
    hasReCall: boolean;
    point: number;
    level: number;
    wealthLevel: number;
    needHideWealthLevel: number;
  }[];
  currentUid: string;
}
type PreLostUserGetUserList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/preLostUser/getUserList',
    'data',
    string,
    string,
    false
  >
>;

const preLostUserGetUserList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/preLostUser/getUserList',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: { 'X-Auth-Token': 'jidouye8798et08er0te0r89t' },
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'preLostUserGetUserList3957',
};

export const preLostUserGetUserList3957 = makeRequest<
  PreLostUserGetUserList3957Request,
  PreLostUserGetUserList3957Response
>(preLostUserGetUserList3957RequestConfig);
export const usePreLostUserGetUserList3957 = makeRequestHook<
  PreLostUserGetUserList3957Request,
  PreLostUserGetUserList3957RequestConfig,
  ReturnType<typeof preLostUserGetUserList3957>
>(preLostUserGetUserList3957);

export interface PreLostUserSendRecallIm3957Request {
  /**
   * "快来玩呀"
   */
  content: string;
  /**
   * 1
   */
  dataType: number;
  /**
   * "2022-08-22"
   */
  day: string;
  /**
   * "玩"
   */
  title: string;
  /**
   * [123455,123456]
   */
  uidList: number[];
}

export type PreLostUserSendRecallIm3957Response = boolean;
type PreLostUserSendRecallIm3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/preLostUser/sendRecallIm',
    'data',
    string,
    string,
    false
  >
>;

const preLostUserSendRecallIm3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/preLostUser/sendRecallIm',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: { 'X-Auth-Token': 'dfkglkdg9hl;kdofhkldf' },
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'preLostUserSendRecallIm3957',
};

export const preLostUserSendRecallIm3957 = makeRequest<
  PreLostUserSendRecallIm3957Request,
  PreLostUserSendRecallIm3957Response
>(preLostUserSendRecallIm3957RequestConfig);
export const usePreLostUserSendRecallIm3957 = makeRequestHook<
  PreLostUserSendRecallIm3957Request,
  PreLostUserSendRecallIm3957RequestConfig,
  ReturnType<typeof preLostUserSendRecallIm3957>
>(preLostUserSendRecallIm3957);

export interface PreLostUserDrawRecallReward3957Request {
  /**
   * 12345
   */
  anchorUid: number;
  /**
   * 16712345678
   */
  ctime: number;
}

export type PreLostUserDrawRecallReward3957Response = boolean;
type PreLostUserDrawRecallReward3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/preLostUser/drawRecallReward',
    'data',
    string,
    string,
    false
  >
>;

const preLostUserDrawRecallReward3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/preLostUser/drawRecallReward',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'preLostUserDrawRecallReward3957',
};

export const preLostUserDrawRecallReward3957 = makeRequest<
  PreLostUserDrawRecallReward3957Request,
  PreLostUserDrawRecallReward3957Response
>(preLostUserDrawRecallReward3957RequestConfig);
export const usePreLostUserDrawRecallReward3957 = makeRequestHook<
  PreLostUserDrawRecallReward3957Request,
  PreLostUserDrawRecallReward3957RequestConfig,
  ReturnType<typeof preLostUserDrawRecallReward3957>
>(preLostUserDrawRecallReward3957);

export interface PreLostUserOpenRecallIm3957Request {
  /**
   * 1600003313
   */
  anchorUid: number;
  /**
   * 1660568575
   */
  ctime: number;
}

export interface PreLostUserOpenRecallIm3957Response {
  title: string;
  content: string;
  hasAccepted: number;
  rewardsList: {
    type: number;
    icon: string;
    count: number;
    day: number;
  }[];
  anchorInfo: {
    uid: number;
    nickname: string;
    avatar: string;
    bigoid: string;
  };
  userInfo: {
    uid: number;
    nickname: string;
    avatar: string;
    bigoid: string;
  };
}
type PreLostUserOpenRecallIm3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/preLostUser/openRecallIm',
    'data',
    string,
    string,
    false
  >
>;

const preLostUserOpenRecallIm3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/preLostUser/openRecallIm',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'preLostUserOpenRecallIm3957',
};

export const preLostUserOpenRecallIm3957 = makeRequest<
  PreLostUserOpenRecallIm3957Request,
  PreLostUserOpenRecallIm3957Response
>(preLostUserOpenRecallIm3957RequestConfig);
export const usePreLostUserOpenRecallIm3957 = makeRequestHook<
  PreLostUserOpenRecallIm3957Request,
  PreLostUserOpenRecallIm3957RequestConfig,
  ReturnType<typeof preLostUserOpenRecallIm3957>
>(preLostUserOpenRecallIm3957);

export interface GetBanner3957Request {
  /**
   * "ios"
   */
  platform: string;
}

export type GetBanner3957Response =
  | []
  | [
      {
        banner: string;
        link: string;
        id: number;
        name: string;
      },
    ];
type GetBanner3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/getBanner',
    'data',
    string,
    string,
    false
  >
>;

const getBanner3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/getBanner',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: { 'X-Auth-Token': 'jidouye8798et08er0te0r89t' },
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'getBanner3957',
};

export const getBanner3957 = makeRequest<GetBanner3957Request, GetBanner3957Response>(
  getBanner3957RequestConfig,
);
export const useGetBanner3957 = makeRequestHook<
  GetBanner3957Request,
  GetBanner3957RequestConfig,
  ReturnType<typeof getBanner3957>
>(getBanner3957);

export interface PreLostUserQueryRecallReward3957Request {}

export type PreLostUserQueryRecallReward3957Response =
  | []
  | [
      {
        type: number;
        icon: string;
        count: number;
        day: number;
      },
    ];
type PreLostUserQueryRecallReward3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/preLostUser/queryRecallReward',
    'data',
    string,
    string,
    true
  >
>;

const preLostUserQueryRecallReward3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/preLostUser/queryRecallReward',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: { 'X-Auth-Token': 'jidouye8798et08er0te0r89t' },
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'preLostUserQueryRecallReward3957',
};

export const preLostUserQueryRecallReward3957 = makeRequest<
  PreLostUserQueryRecallReward3957Request,
  PreLostUserQueryRecallReward3957Response
>(preLostUserQueryRecallReward3957RequestConfig);
export const usePreLostUserQueryRecallReward3957 = makeRequestHook<
  PreLostUserQueryRecallReward3957Request,
  PreLostUserQueryRecallReward3957RequestConfig,
  ReturnType<typeof preLostUserQueryRecallReward3957>
>(preLostUserQueryRecallReward3957);

export interface PreLostUserCallbackUser3957Request {
  /**
   * 1
   */
  dataType: number;
  /**
   * "2022-08-15"
   */
  day: string;
}

export interface PreLostUserCallbackUser3957Response {
  callbackUser: number;
}
type PreLostUserCallbackUser3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/preLostUser/callbackUser',
    'data',
    string,
    string,
    false
  >
>;

const preLostUserCallbackUser3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/preLostUser/callbackUser',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: { 'X-Auth-Token': 'jidouye8798et08er0te0r89t' },
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'preLostUserCallbackUser3957',
};

export const preLostUserCallbackUser3957 = makeRequest<
  PreLostUserCallbackUser3957Request,
  PreLostUserCallbackUser3957Response
>(preLostUserCallbackUser3957RequestConfig);
export const usePreLostUserCallbackUser3957 = makeRequestHook<
  PreLostUserCallbackUser3957Request,
  PreLostUserCallbackUser3957RequestConfig,
  ReturnType<typeof preLostUserCallbackUser3957>
>(preLostUserCallbackUser3957);

export interface Act69322TestProduce3957Request {
  /**
   * "500140021"
   */
  uid: string;
  /**
   * "HK"
   */
  area: string;
  /**
   * "abc"
   */
  campaign: string;
  /**
   * "1010"
   */
  ios_install_num: string;
  /**
   * "1001"
   */
  ios_retention_day_1: string;
  /**
   * "1012"
   */
  android_install_num: string;
  /**
   * "1004"
   */
  android_retention_day_1: string;
  /**
   * "2022"
   */
  install_num: string;
  /**
   * "2005"
   */
  retention_day_1: string;
  /**
   * "2023-10-06"
   */
  stat_day: string;
}

export interface Act69322TestProduce3957Response {}
type Act69322TestProduce3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act69322/test/produce',
    'data',
    string,
    string,
    false
  >
>;

const act69322TestProduce3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_0,
  path: '/bigo_act_livedata_api/act69322/test/produce',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act69322TestProduce3957',
};

export const act69322TestProduce3957 = makeRequest<
  Act69322TestProduce3957Request,
  Act69322TestProduce3957Response
>(act69322TestProduce3957RequestConfig);
export const useAct69322TestProduce3957 = makeRequestHook<
  Act69322TestProduce3957Request,
  Act69322TestProduce3957RequestConfig,
  ReturnType<typeof act69322TestProduce3957>
>(act69322TestProduce3957);

const mockUrl_2_0_0_1 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_1 = 'data' as any;

export interface MultiRoomDay3957Request {
  from: string;
  to: string;
}

export interface MultiRoomDay3957Response {
  baseData: {
    roombeans: {
      id: string;
      num: number;
      rate: number;
    };
    ownerbeans: {
      id: string;
      num: number;
      rate: number;
    };
    micers: {
      id: string;
      num: number;
      rate: number;
    };
    micbeans: {
      id: string;
      num: number;
      rate: number;
    };
    stime: {
      id: string;
      num: number;
      rate: number;
    };
    micstime: {
      id: string;
      num: number;
      rate: number;
    };
    sday: {
      id: string;
      num: number;
      rate: number;
    };
  };
}
type MultiRoomDay3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/multiRoomDay',
    'data',
    string,
    string,
    false
  >
>;

const multiRoomDay3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_1,
  path: '/bigo_act_livedata_api/multiRoomDay',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'multiRoomDay3957',
};

export const multiRoomDay3957 = makeRequest<MultiRoomDay3957Request, MultiRoomDay3957Response>(
  multiRoomDay3957RequestConfig,
);
export const useMultiRoomDay3957 = makeRequestHook<
  MultiRoomDay3957Request,
  MultiRoomDay3957RequestConfig,
  ReturnType<typeof multiRoomDay3957>
>(multiRoomDay3957);

export interface MultiRoomMonth3957Request {
  from: string;
}

export interface MultiRoomMonth3957Response {
  baseData: {
    roombeans: {
      id: string;
      num: number;
      rate: number;
    };
    ownerbeans: {
      id: string;
      num: number;
      rate: number;
    };
    micers: {
      id: string;
      num: number;
      rate: number;
    };
    micbeans: {
      id: string;
      num: number;
      rate: number;
    };
    stime: {
      id: string;
      num: number;
      rate: number;
    };
    micstime: {
      id: string;
      num: number;
      rate: number;
    };
    sday: {
      id: string;
      num: number;
      rate: number;
    };
  };
}
type MultiRoomMonth3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/multiRoomMonth',
    'data',
    string,
    string,
    false
  >
>;

const multiRoomMonth3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_1,
  path: '/bigo_act_livedata_api/multiRoomMonth',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'multiRoomMonth3957',
};

export const multiRoomMonth3957 = makeRequest<
  MultiRoomMonth3957Request,
  MultiRoomMonth3957Response
>(multiRoomMonth3957RequestConfig);
export const useMultiRoomMonth3957 = makeRequestHook<
  MultiRoomMonth3957Request,
  MultiRoomMonth3957RequestConfig,
  ReturnType<typeof multiRoomMonth3957>
>(multiRoomMonth3957);

export interface MultiRoomGraph3957Request {
  /**
   * 日期统计类型，day：按日期；month：月份
   */
  stat_type: string;
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 结束日期，统计类型为月份时可不传
   */
  to?: string;
}

export interface MultiRoomGraph3957Response {
  list: {
    xname: string;
    roombeans: number;
    ownerbeans: number;
    micers: number;
    micbeans: number;
    stime: number;
    micstime: number;
    sday: number;
  }[];
}
type MultiRoomGraph3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/multiRoomGraph',
    'data',
    string,
    string,
    false
  >
>;

const multiRoomGraph3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_1,
  path: '/bigo_act_livedata_api/multiRoomGraph',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'multiRoomGraph3957',
};

export const multiRoomGraph3957 = makeRequest<
  MultiRoomGraph3957Request,
  MultiRoomGraph3957Response
>(multiRoomGraph3957RequestConfig);
export const useMultiRoomGraph3957 = makeRequestHook<
  MultiRoomGraph3957Request,
  MultiRoomGraph3957RequestConfig,
  ReturnType<typeof multiRoomGraph3957>
>(multiRoomGraph3957);

export interface MultiRoomDetail3957Request {
  /**
   * "month"
   */
  stat_type: string;
  /**
   * "2025-01"
   */
  from: string;
  to: string;
  /**
   * "0"
   */
  page: string;
  /**
   * "819917961"
   */
  anchorUid: string;
  /**
   * "abc"
   */
  columnName: string;
}

export interface MultiRoomDetail3957Response {
  isLastPage: boolean;
  list: {
    nickname: string;
    avatar: string;
    bigoid: string;
    micbeans: number;
    micstime: number;
  }[];
}
type MultiRoomDetail3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/multiRoomDetail',
    'data',
    string,
    string,
    false
  >
>;

const multiRoomDetail3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_1,
  path: '/bigo_act_livedata_api/multiRoomDetail',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'multiRoomDetail3957',
};

export const multiRoomDetail3957 = makeRequest<
  MultiRoomDetail3957Request,
  MultiRoomDetail3957Response
>(multiRoomDetail3957RequestConfig);
export const useMultiRoomDetail3957 = makeRequestHook<
  MultiRoomDetail3957Request,
  MultiRoomDetail3957RequestConfig,
  ReturnType<typeof multiRoomDetail3957>
>(multiRoomDetail3957);

export interface MultiRoomExportUrl3957Request {
  /**
   * 日期统计类型，day：按日期；month：月份
   */
  stat_type: string;
  /**
   * 数据类型，owner：主播数据；micers：嘉宾数据明细
   */
  data_type: string;
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 结束日期，统计类型为月份时可不传
   */
  to?: string;
  /**
   * bigolive 60 funkie 72
   */
  appId: string;
  /**
   * 83943需求新增：字段名
   */
  columnName?: string;
}

export interface MultiRoomExportUrl3957Response {
  url: string;
}
type MultiRoomExportUrl3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/multiRoomExportUrl',
    'data',
    string,
    string,
    false
  >
>;

const multiRoomExportUrl3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_1,
  path: '/bigo_act_livedata_api/multiRoomExportUrl',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'multiRoomExportUrl3957',
};

export const multiRoomExportUrl3957 = makeRequest<
  MultiRoomExportUrl3957Request,
  MultiRoomExportUrl3957Response
>(multiRoomExportUrl3957RequestConfig);
export const useMultiRoomExportUrl3957 = makeRequestHook<
  MultiRoomExportUrl3957Request,
  MultiRoomExportUrl3957RequestConfig,
  ReturnType<typeof multiRoomExportUrl3957>
>(multiRoomExportUrl3957);

export interface InnerMultiList3957Request {
  /**
   * 999
   */
  seqId: number;
  from: string;
  /**
   * 99
   */
  timestamp: number;
  /**
   * "aa"
   */
  sign: string;
  /**
   * 111
   */
  uid: number;
  /**
   * "2024-11-11"
   */
  startTime: string;
  /**
   * "2024-11-11"
   */
  endTime: string;
}

export interface InnerMultiList3957Response {
  seqId: number;
  details: {
    date: string;
    voiceRoomTotalBeans: string;
    voiceRoomStime: string;
    voiceRoomAnchorBeans: string;
    voiceRoomAnchorStime: string;
    voiceRoomAnchorSday: string;
  }[];
}
type InnerMultiList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/multi/list',
    'data',
    string,
    string,
    false
  >
>;

const innerMultiList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_1,
  path: '/bigo_act_livedata_api/inner/multi/list',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerMultiList3957',
};

export const innerMultiList3957 = makeRequest<
  InnerMultiList3957Request,
  InnerMultiList3957Response
>(innerMultiList3957RequestConfig);
export const useInnerMultiList3957 = makeRequestHook<
  InnerMultiList3957Request,
  InnerMultiList3957RequestConfig,
  ReturnType<typeof innerMultiList3957>
>(innerMultiList3957);

const mockUrl_2_0_0_2 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_2 = 'data' as any;

export interface ManageOssGetRewardList3957Request {
  /**
   * 1
   */
  actId: number;
  /**
   * 1687
   */
  rewardId: number;
  /**
   * 150123467
   */
  anchorUid: number;
  /**
   * 150321456
   */
  userUid: number;
  /**
   * 1
   */
  rewardType: number;
  /**
   * 1
   */
  status: number;
  /**
   * 1
   */
  pageIndex: number;
  /**
   * 10
   */
  pageSize: number;
  /**
   * 1660200790
   */
  beginTime: number;
  /**
   * 1660201790
   */
  endTime: number;
}

export type ManageOssGetRewardList3957Response = any;
type ManageOssGetRewardList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/manageOss/getRewardList',
    'data',
    string,
    string,
    false
  >
>;

const manageOssGetRewardList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_2,
  path: '/bigo_act_livedata_api/manageOss/getRewardList',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: { sign: '4igyurtyuwr867oyuktgyjurty', timestamp: '1501234567' },
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.raw,
  dataKey: dataKey_2_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'manageOssGetRewardList3957',
};

export const manageOssGetRewardList3957 = makeRequest<
  ManageOssGetRewardList3957Request,
  ManageOssGetRewardList3957Response
>(manageOssGetRewardList3957RequestConfig);
export const useManageOssGetRewardList3957 = makeRequestHook<
  ManageOssGetRewardList3957Request,
  ManageOssGetRewardList3957RequestConfig,
  ReturnType<typeof manageOssGetRewardList3957>
>(manageOssGetRewardList3957);

const mockUrl_2_0_0_3 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_3 = 'data' as any;

export interface CreatorAchieveLevel3957Request {}

export interface CreatorAchieveLevel3957Response {
  beanLimit: number;
  beanProcess: number;
  curBadgeUrl: string;
  fansLimit: number;
  fansProcess: number;
  liveTimeLimit: number;
  liveTimeProcess: number;
}
type CreatorAchieveLevel3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/creator/achieveLevel',
    'data',
    string,
    string,
    true
  >
>;

const creatorAchieveLevel3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_3,
  path: '/bigo_act_livedata_api/creator/achieveLevel',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: { 'X-Auth-Token': 'WEB3@tech98^*we' },
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'creatorAchieveLevel3957',
};

export const creatorAchieveLevel3957 = makeRequest<
  CreatorAchieveLevel3957Request,
  CreatorAchieveLevel3957Response
>(creatorAchieveLevel3957RequestConfig);
export const useCreatorAchieveLevel3957 = makeRequestHook<
  CreatorAchieveLevel3957Request,
  CreatorAchieveLevel3957RequestConfig,
  ReturnType<typeof creatorAchieveLevel3957>
>(creatorAchieveLevel3957);

export interface CreatorLiveOrder3957Request {}

export interface CreatorLiveOrder3957Response {
  isOrder: number;
  nextLiveTime: number;
  orderNum: number;
  orderType: number;
}
type CreatorLiveOrder3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/creator/liveOrder',
    'data',
    string,
    string,
    true
  >
>;

const creatorLiveOrder3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_3,
  path: '/bigo_act_livedata_api/creator/liveOrder',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: { 'X-Auth-Token': 'WEB3@tech98^*we' },
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'creatorLiveOrder3957',
};

export const creatorLiveOrder3957 = makeRequest<
  CreatorLiveOrder3957Request,
  CreatorLiveOrder3957Response
>(creatorLiveOrder3957RequestConfig);
export const useCreatorLiveOrder3957 = makeRequestHook<
  CreatorLiveOrder3957Request,
  CreatorLiveOrder3957RequestConfig,
  ReturnType<typeof creatorLiveOrder3957>
>(creatorLiveOrder3957);

export interface CreatorLivedata3957Request {}

export interface CreatorLivedata3957Response {
  anchorType: number;
  avatar: string;
  username: string;
  inOutBeanSum: number;
  beans: number;
  packGiftBeans: number;
  fans: number;
  liveDays: number;
  liveTime: number;
  updateDay: string;
  showRealLiveTime: boolean;
  realLiveTime: number;
  month: string;
  currency: string;
  currencyUnit: string;
  showSignAnchor: boolean;
  bigoId: string;
  showNewAnchor: boolean;
  newAnchorGrade: {
    beginDate: string;
    endDate: string;
    grade: number;
    score: number;
  };
  gradeScoreInfos: {
    grade: number;
    minScore: number;
    maxScore: number;
  }[];
}
type CreatorLivedata3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/creator/livedata',
    'data',
    string,
    string,
    true
  >
>;

const creatorLivedata3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_3,
  path: '/bigo_act_livedata_api/creator/livedata',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'creatorLivedata3957',
};

export const creatorLivedata3957 = makeRequest<
  CreatorLivedata3957Request,
  CreatorLivedata3957Response
>(creatorLivedata3957RequestConfig);
export const useCreatorLivedata3957 = makeRequestHook<
  CreatorLivedata3957Request,
  CreatorLivedata3957RequestConfig,
  ReturnType<typeof creatorLivedata3957>
>(creatorLivedata3957);

export interface BigoliveLiveGlobalMiscLiveCoverLowQuality3957Request {}

export interface BigoliveLiveGlobalMiscLiveCoverLowQuality3957Response {
  err_code: number;
  low_qualit_threshold: number;
  results: {
    error_code: number;
    low_quality_score: number;
  }[];
}
type BigoliveLiveGlobalMiscLiveCoverLowQuality3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/bigolive/live_global_misc/LiveCoverLowQuality',
    'data',
    string,
    string,
    true
  >
>;

const bigoliveLiveGlobalMiscLiveCoverLowQuality3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_3,
  path: '/bigo_act_livedata_api/bigolive/live_global_misc/LiveCoverLowQuality',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'bigoliveLiveGlobalMiscLiveCoverLowQuality3957',
};

export const bigoliveLiveGlobalMiscLiveCoverLowQuality3957 = makeRequest<
  BigoliveLiveGlobalMiscLiveCoverLowQuality3957Request,
  BigoliveLiveGlobalMiscLiveCoverLowQuality3957Response
>(bigoliveLiveGlobalMiscLiveCoverLowQuality3957RequestConfig);
export const useBigoliveLiveGlobalMiscLiveCoverLowQuality3957 = makeRequestHook<
  BigoliveLiveGlobalMiscLiveCoverLowQuality3957Request,
  BigoliveLiveGlobalMiscLiveCoverLowQuality3957RequestConfig,
  ReturnType<typeof bigoliveLiveGlobalMiscLiveCoverLowQuality3957>
>(bigoliveLiveGlobalMiscLiveCoverLowQuality3957);

const mockUrl_2_0_0_4 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_4 = 'data' as any;

export interface AgentOssExportUrl3957Request {
  /**
   * 结束时间 格式：2023-02-24
   */
  endTime: string;
  /**
   * true
   */
  isExport: boolean;
  operateUid: number;
  page: number;
  pageSize: number;
  /**
   * 代理uid
   * dataType = 1时，传0
   * dataType = 2时，传具体的代理uid
   */
  proxyUid: string;
  queryDay: string;
  /**
   * 开始时间 格式：2023-02-24
   */
  startTime: string;
  /**
   * 数据种类 0全部 1金豆 2时长 3天数 4粉丝数
   */
  tabs: string;
  /**
   * 1: 代理明细数据 2: 主播明细数据
   */
  dataType: string;
}

export type AgentOssExportUrl3957Response = string;
type AgentOssExportUrl3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/exportUrl',
    'data',
    string,
    'startTime' | 'endTime' | 'proxyUid' | 'tabs' | 'dataType',
    false
  >
>;

const agentOssExportUrl3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_4,
  path: '/bigo_act_livedata_api/agentOss/exportUrl',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_4,
  paramNames: [],
  queryNames: ['startTime', 'endTime', 'proxyUid', 'tabs', 'dataType'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssExportUrl3957',
};

export const agentOssExportUrl3957 = makeRequest<
  AgentOssExportUrl3957Request,
  AgentOssExportUrl3957Response
>(agentOssExportUrl3957RequestConfig);
export const useAgentOssExportUrl3957 = makeRequestHook<
  AgentOssExportUrl3957Request,
  AgentOssExportUrl3957RequestConfig,
  ReturnType<typeof agentOssExportUrl3957>
>(agentOssExportUrl3957);

const mockUrl_2_0_0_5 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_5 = 'data' as any;

export interface BrokerageBackendProxyBenefitByType3957Request {
  /**
   * 1
   */
  isSalary: number;
  /**
   * "2023-08-09"
   */
  startTime: string;
  /**
   * "2023-08-09"
   */
  endTime: string;
  /**
   * "2023-08-10"
   */
  dayOffset: string;
  /**
   * 1
   */
  reqType: number;
  /**
   * 400130029
   */
  proxyUid: number;
  /**
   * 400130029
   */
  brokerUid: number;
}

export interface BrokerageBackendProxyBenefitByType3957Response {
  dayOffset: string;
  total: number;
  dayBenefitListByTypes: {
    date: string;
    isSalary: number;
    totalBenefitOfDay: number;
    typeBenefitInfos:
      | []
      | [
          {
            typeKey: string;
            typeName: string;
            typeIcon: string;
            typeValue: number;
          },
        ];
  }[];
}
type BrokerageBackendProxyBenefitByType3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/brokerageBackend/proxyBenefitByType',
    'data',
    string,
    string,
    false
  >
>;

const brokerageBackendProxyBenefitByType3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_5,
  path: '/bigo_act_livedata_api/brokerageBackend/proxyBenefitByType',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brokerageBackendProxyBenefitByType3957',
};

export const brokerageBackendProxyBenefitByType3957 = makeRequest<
  BrokerageBackendProxyBenefitByType3957Request,
  BrokerageBackendProxyBenefitByType3957Response
>(brokerageBackendProxyBenefitByType3957RequestConfig);
export const useBrokerageBackendProxyBenefitByType3957 = makeRequestHook<
  BrokerageBackendProxyBenefitByType3957Request,
  BrokerageBackendProxyBenefitByType3957RequestConfig,
  ReturnType<typeof brokerageBackendProxyBenefitByType3957>
>(brokerageBackendProxyBenefitByType3957);

export interface BrokerageBackendAnchorBenefitByType3957Request {
  /**
   * 1
   */
  isSalary: number;
  /**
   * "2023-08-09"
   */
  startTime: string;
  /**
   * "2023-08-09"
   */
  endTime: string;
  /**
   * "2023-08-10"
   */
  dayOffset: string;
  /**
   * 1
   */
  reqType: number;
}

export interface BrokerageBackendAnchorBenefitByType3957Response {
  dayOffset: string;
  dayBenefitListByTypes: {
    date: string;
    isSalary: number;
    totalBenefitOfDay: number;
    showNoSalaryEntry: boolean;
    typeBenefitInfos:
      | []
      | [
          {
            typeKey: number;
            typeName: string;
            typeIcon: string;
            typeValue: number;
          },
        ];
  }[];
}
type BrokerageBackendAnchorBenefitByType3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/brokerageBackend/anchorBenefitByType',
    'data',
    string,
    string,
    false
  >
>;

const brokerageBackendAnchorBenefitByType3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_5,
  path: '/bigo_act_livedata_api/brokerageBackend/anchorBenefitByType',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brokerageBackendAnchorBenefitByType3957',
};

export const brokerageBackendAnchorBenefitByType3957 = makeRequest<
  BrokerageBackendAnchorBenefitByType3957Request,
  BrokerageBackendAnchorBenefitByType3957Response
>(brokerageBackendAnchorBenefitByType3957RequestConfig);
export const useBrokerageBackendAnchorBenefitByType3957 = makeRequestHook<
  BrokerageBackendAnchorBenefitByType3957Request,
  BrokerageBackendAnchorBenefitByType3957RequestConfig,
  ReturnType<typeof brokerageBackendAnchorBenefitByType3957>
>(brokerageBackendAnchorBenefitByType3957);

export interface BrokerageBackendAnchorList3957Request {
  startTime: string;
  endTime: string;
  page: number;
  pageSize: number;
  proxyUid: number;
  queryDay: string;
  tabs: number;
  lastUid?: number;
}

export interface BrokerageBackendAnchorList3957Response {
  detail: {
    day: string;
    list:
      | []
      | [
          {
            uid: number;
            id: string;
            statDay: string;
            nums: number;
            subNums: number;
            nickName: string;
            avatar: string;
          },
        ];
    total: number;
  }[];
  endTime: string;
  nextQueryDay: string;
  nextPage: number;
  startTime: string;
  total: number;
}
type BrokerageBackendAnchorList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/brokerageBackend/anchorList',
    'data',
    string,
    string,
    false
  >
>;

const brokerageBackendAnchorList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_5,
  path: '/bigo_act_livedata_api/brokerageBackend/anchorList',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brokerageBackendAnchorList3957',
};

export const brokerageBackendAnchorList3957 = makeRequest<
  BrokerageBackendAnchorList3957Request,
  BrokerageBackendAnchorList3957Response
>(brokerageBackendAnchorList3957RequestConfig);
export const useBrokerageBackendAnchorList3957 = makeRequestHook<
  BrokerageBackendAnchorList3957Request,
  BrokerageBackendAnchorList3957RequestConfig,
  ReturnType<typeof brokerageBackendAnchorList3957>
>(brokerageBackendAnchorList3957);

export interface BrokerageBackendAnchorListByType3957Request {
  queryDay: string;
  proxyUid: number;
  page: number;
  pageSize: number;
  tabs: number;
  /**
   * 1
   */
  salaryType: number;
  /**
   * 1
   */
  subType: number;
}

export interface BrokerageBackendAnchorListByType3957Response {
  typeBenefitInfos: {
    typeKey: number;
    typeName: string;
    typeIcon: string;
    typeValue: number;
  }[];
  salarySubTypeData: {
    typeKey: number;
    typeName: string;
    typeIcon: string;
    typeValue: number;
  };
  list: {
    avatar: string;
    fcnt: number;
    id: string;
    nickName: string;
    sbeans: number;
    sday: number;
    statDay: string;
    stime: number;
    uid: number;
  }[];
  nextPage: number;
}
type BrokerageBackendAnchorListByType3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/brokerageBackend/anchorListByType',
    'data',
    string,
    string,
    false
  >
>;

const brokerageBackendAnchorListByType3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_5,
  path: '/bigo_act_livedata_api/brokerageBackend/anchorListByType',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brokerageBackendAnchorListByType3957',
};

export const brokerageBackendAnchorListByType3957 = makeRequest<
  BrokerageBackendAnchorListByType3957Request,
  BrokerageBackendAnchorListByType3957Response
>(brokerageBackendAnchorListByType3957RequestConfig);
export const useBrokerageBackendAnchorListByType3957 = makeRequestHook<
  BrokerageBackendAnchorListByType3957Request,
  BrokerageBackendAnchorListByType3957RequestConfig,
  ReturnType<typeof brokerageBackendAnchorListByType3957>
>(brokerageBackendAnchorListByType3957);

export interface BrokerageBackendTypeRulePage3957Request {
  /**
   * 1
   */
  reqType: number;
}

export interface BrokerageBackendTypeRulePage3957Response {
  allTypeList: {
    typeKey: string;
    typeLang: string;
    descLang: string;
    icon: string;
  }[];
}
type BrokerageBackendTypeRulePage3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/brokerageBackend/typeRulePage',
    'data',
    string,
    string,
    false
  >
>;

const brokerageBackendTypeRulePage3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_5,
  path: '/bigo_act_livedata_api/brokerageBackend/typeRulePage',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brokerageBackendTypeRulePage3957',
};

export const brokerageBackendTypeRulePage3957 = makeRequest<
  BrokerageBackendTypeRulePage3957Request,
  BrokerageBackendTypeRulePage3957Response
>(brokerageBackendTypeRulePage3957RequestConfig);
export const useBrokerageBackendTypeRulePage3957 = makeRequestHook<
  BrokerageBackendTypeRulePage3957Request,
  BrokerageBackendTypeRulePage3957RequestConfig,
  ReturnType<typeof brokerageBackendTypeRulePage3957>
>(brokerageBackendTypeRulePage3957);

export interface BrokerageBackendSuperiorRoleAnchorBenefitByType3957Request {
  /**
   * 1
   */
  isSalary: number;
  /**
   * "2023-08-09"
   */
  startTime: string;
  /**
   * "2023-08-09"
   */
  endTime: string;
  /**
   * "2023-08-10"
   */
  dayOffset: string;
  /**
   * 1
   */
  reqType: number;
  /**
   * 123333
   */
  anchorUid: number;
}

export interface BrokerageBackendSuperiorRoleAnchorBenefitByType3957Response {
  dayOffset: string;
  dayBenefitListByTypes: {
    date: string;
    isSalary: number;
    totalBenefitOfDay: number;
    showNoSalaryEntry: boolean;
    typeBenefitInfos:
      | []
      | [
          {
            typeKey: number;
            typeName: string;
            typeIcon: string;
            typeValue: number;
          },
        ];
  }[];
}
type BrokerageBackendSuperiorRoleAnchorBenefitByType3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/brokerageBackend/superiorRole/anchorBenefitByType',
    'data',
    string,
    string,
    false
  >
>;

const brokerageBackendSuperiorRoleAnchorBenefitByType3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_5,
  path: '/bigo_act_livedata_api/brokerageBackend/superiorRole/anchorBenefitByType',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'brokerageBackendSuperiorRoleAnchorBenefitByType3957',
};

export const brokerageBackendSuperiorRoleAnchorBenefitByType3957 = makeRequest<
  BrokerageBackendSuperiorRoleAnchorBenefitByType3957Request,
  BrokerageBackendSuperiorRoleAnchorBenefitByType3957Response
>(brokerageBackendSuperiorRoleAnchorBenefitByType3957RequestConfig);
export const useBrokerageBackendSuperiorRoleAnchorBenefitByType3957 = makeRequestHook<
  BrokerageBackendSuperiorRoleAnchorBenefitByType3957Request,
  BrokerageBackendSuperiorRoleAnchorBenefitByType3957RequestConfig,
  ReturnType<typeof brokerageBackendSuperiorRoleAnchorBenefitByType3957>
>(brokerageBackendSuperiorRoleAnchorBenefitByType3957);

const mockUrl_2_0_0_7 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_7 = 'data' as any;

export interface Inner_66965MultiQueryLiveData3957Request {
  /**
   * 12324355
   */
  seqId: number;
  from: string;
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-03-10"
   */
  endTime: string;
  /**
   * [500140021]
   */
  anchorUidList: number[];
  /**
   * [1]
   */
  tabs: number[];
  /**
   * 1690424937
   */
  timestamp: number;
  /**
   * "1855d2e190de5040d0b21cd8c48f486bc14c56440934785628b5407931600203"
   */
  sign: string;
}

export interface Inner_66965MultiQueryLiveData3957Response {
  seqId: number;
  resLiveDataMap: {
    '500140021': {
      bean: number;
      liveTime: number;
      fans: number;
      liveDay: number;
    };
  };
}
type Inner_66965MultiQueryLiveData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/66965/multiQueryLiveData',
    'data',
    string,
    string,
    false
  >
>;

const inner_66965MultiQueryLiveData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/66965/multiQueryLiveData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'inner_66965MultiQueryLiveData3957',
};

export const inner_66965MultiQueryLiveData3957 = makeRequest<
  Inner_66965MultiQueryLiveData3957Request,
  Inner_66965MultiQueryLiveData3957Response
>(inner_66965MultiQueryLiveData3957RequestConfig);
export const useInner_66965MultiQueryLiveData3957 = makeRequestHook<
  Inner_66965MultiQueryLiveData3957Request,
  Inner_66965MultiQueryLiveData3957RequestConfig,
  ReturnType<typeof inner_66965MultiQueryLiveData3957>
>(inner_66965MultiQueryLiveData3957);

export interface Inner_66965GetAnchorDailyData3957Request {
  /**
   * 12324355
   */
  seqId: number;
  from: string;
  /**
   * 1690424937
   */
  timestamp: number;
  /**
   * "1855d2e190de5040d0b21cd8c48f486bc14c56440934785628b5407931600203"
   */
  sign: string;
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-03-10"
   */
  endTime: string;
  /**
   * 500140021
   */
  uid: number;
}

export interface Inner_66965GetAnchorDailyData3957Response {
  seqId: number;
  beanTotal: number;
  liveTimeTotal: number;
  fansTotal: number;
  liveDayTotal: number;
  detail: {
    date: string;
    bean: number;
    liveTime: number;
    fans: number;
    liveDay: number;
  }[];
}
type Inner_66965GetAnchorDailyData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/66965/getAnchorDailyData',
    'data',
    string,
    string,
    false
  >
>;

const inner_66965GetAnchorDailyData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/66965/getAnchorDailyData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'inner_66965GetAnchorDailyData3957',
};

export const inner_66965GetAnchorDailyData3957 = makeRequest<
  Inner_66965GetAnchorDailyData3957Request,
  Inner_66965GetAnchorDailyData3957Response
>(inner_66965GetAnchorDailyData3957RequestConfig);
export const useInner_66965GetAnchorDailyData3957 = makeRequestHook<
  Inner_66965GetAnchorDailyData3957Request,
  Inner_66965GetAnchorDailyData3957RequestConfig,
  ReturnType<typeof inner_66965GetAnchorDailyData3957>
>(inner_66965GetAnchorDailyData3957);

export interface Inner_66965MultiQueryNoSignLiveData3957Request {
  /**
   * 12324355
   */
  seqId: number;
  from: string;
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-03-10"
   */
  endTime: string;
  /**
   * [500140021]
   */
  anchorUidList: number[];
  /**
   * 1690424937
   */
  timestamp: number;
  /**
   * "1855d2e190de5040d0b21cd8c48f486bc14c56440934785628b5407931600203"
   */
  sign: string;
}

export interface Inner_66965MultiQueryNoSignLiveData3957Response {
  seqId: number;
  resLiveDataMap: {
    '500140021': {
      bean: number;
      liveTime: number;
      fans: number;
    };
  };
}
type Inner_66965MultiQueryNoSignLiveData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/66965/multiQueryNoSignLiveData',
    'data',
    string,
    string,
    false
  >
>;

const inner_66965MultiQueryNoSignLiveData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/66965/multiQueryNoSignLiveData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'inner_66965MultiQueryNoSignLiveData3957',
};

export const inner_66965MultiQueryNoSignLiveData3957 = makeRequest<
  Inner_66965MultiQueryNoSignLiveData3957Request,
  Inner_66965MultiQueryNoSignLiveData3957Response
>(inner_66965MultiQueryNoSignLiveData3957RequestConfig);
export const useInner_66965MultiQueryNoSignLiveData3957 = makeRequestHook<
  Inner_66965MultiQueryNoSignLiveData3957Request,
  Inner_66965MultiQueryNoSignLiveData3957RequestConfig,
  ReturnType<typeof inner_66965MultiQueryNoSignLiveData3957>
>(inner_66965MultiQueryNoSignLiveData3957);

export interface Inner_68753QueryCommonLiveData3957Request {
  /**
   * 123456789
   */
  seqId: number;
  /**
   * "66965"
   */
  from: string;
  /**
   * 1693809828
   */
  timestamp: number;
  /**
   * "f858e2a6e5d52d1a14e6ec8145b0d95c9cd3728bebe0391bf2f0da7be7f5b5a5"
   */
  sign: string;
  /**
   * "2023-08-01"
   */
  startTime: string;
  /**
   * "2023-08-31"
   */
  endTime: string;
  /**
   * 500140021
   */
  uid: number;
  dataType: number;
  /**
   * ["sbean","stime","sday","out_region_percent","support_percent"]
   */
  dataKeyList: string[];
}

export interface Inner_68753QueryCommonLiveData3957Response {
  seqId: number;
  uid: number;
  dataList: {
    key: string;
    value: number;
  }[];
}
type Inner_68753QueryCommonLiveData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/68753/queryCommonLiveData',
    'data',
    string,
    string,
    false
  >
>;

const inner_68753QueryCommonLiveData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/68753/queryCommonLiveData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'inner_68753QueryCommonLiveData3957',
};

export const inner_68753QueryCommonLiveData3957 = makeRequest<
  Inner_68753QueryCommonLiveData3957Request,
  Inner_68753QueryCommonLiveData3957Response
>(inner_68753QueryCommonLiveData3957RequestConfig);
export const useInner_68753QueryCommonLiveData3957 = makeRequestHook<
  Inner_68753QueryCommonLiveData3957Request,
  Inner_68753QueryCommonLiveData3957RequestConfig,
  ReturnType<typeof inner_68753QueryCommonLiveData3957>
>(inner_68753QueryCommonLiveData3957);

export interface InnerBaseBean3957Request {
  /**
   * 1600003160
   */
  uid: number;
}

export interface InnerBaseBean3957Response {
  bean: number;
}
type InnerBaseBean3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/base/bean',
    'data',
    string,
    string,
    false
  >
>;

const innerBaseBean3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/base/bean',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerBaseBean3957',
};

export const innerBaseBean3957 = makeRequest<InnerBaseBean3957Request, InnerBaseBean3957Response>(
  innerBaseBean3957RequestConfig,
);
export const useInnerBaseBean3957 = makeRequestHook<
  InnerBaseBean3957Request,
  InnerBaseBean3957RequestConfig,
  ReturnType<typeof innerBaseBean3957>
>(innerBaseBean3957);

export interface Inner_66965GetAnchorDailyData_17300991387903957Request {
  /**
   * 12324355
   */
  seqId: number;
  from: string;
  /**
   * 1690424937
   */
  timestamp: number;
  /**
   * "1855d2e190de5040d0b21cd8c48f486bc14c56440934785628b5407931600203"
   */
  sign: string;
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-03-10"
   */
  endTime: string;
  /**
   * 500140021
   */
  uid: number;
}

export interface Inner_66965GetAnchorDailyData_17300991387903957Response {
  seqId: number;
  beanTotal: number;
  liveTimeTotal: number;
  fansTotal: number;
  liveDayTotal: number;
  detail: {
    date: string;
    bean: number;
    liveTime: number;
    fans: number;
    liveDay: number;
  }[];
}
type Inner_66965GetAnchorDailyData_17300991387903957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/66965/getAnchorDailyData_1730099138790',
    'data',
    string,
    string,
    false
  >
>;

const inner_66965GetAnchorDailyData_17300991387903957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/66965/getAnchorDailyData_1730099138790',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'inner_66965GetAnchorDailyData_17300991387903957',
};

export const inner_66965GetAnchorDailyData_17300991387903957 = makeRequest<
  Inner_66965GetAnchorDailyData_17300991387903957Request,
  Inner_66965GetAnchorDailyData_17300991387903957Response
>(inner_66965GetAnchorDailyData_17300991387903957RequestConfig);
export const useInner_66965GetAnchorDailyData_17300991387903957 = makeRequestHook<
  Inner_66965GetAnchorDailyData_17300991387903957Request,
  Inner_66965GetAnchorDailyData_17300991387903957RequestConfig,
  ReturnType<typeof inner_66965GetAnchorDailyData_17300991387903957>
>(inner_66965GetAnchorDailyData_17300991387903957);

export interface InnerAllMultiQueryLiveData3957Request {
  /**
   * 12324355
   */
  seqId: number;
  from: string;
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-03-10"
   */
  endTime: string;
  /**
   * [9999,8888,7777]
   */
  anchorUidList: number[];
  /**
   * [1]
   */
  tabs: number[];
  /**
   * 1690424937
   */
  timestamp: number;
  /**
   * "1855d2e190de5040d0b21cd8c48f486bc14c56440934785628b5407931600203"
   */
  sign: string;
}

export interface InnerAllMultiQueryLiveData3957Response {
  seqId: number;
  userLiveDataMapPerDay: {
    '500140021': {
      '2024-09-20': {
        bean: number;
        liveTime: number;
        fans: number;
        liveDay: number;
      };
      '2024-09-21': {
        bean: number;
        liveTime: number;
        fans: number;
        liveDay: number;
      };
    };
    '500140022': {
      '2024-09-20': {
        bean: number;
        liveTime: number;
        fans: number;
        liveDay: number;
      };
      '2024-09-21': {
        bean: number;
        liveTime: number;
        fans: number;
        liveDay: number;
      };
    };
  };
}
type InnerAllMultiQueryLiveData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/all/multiQueryLiveData',
    'data',
    string,
    string,
    false
  >
>;

const innerAllMultiQueryLiveData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/all/multiQueryLiveData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerAllMultiQueryLiveData3957',
};

export const innerAllMultiQueryLiveData3957 = makeRequest<
  InnerAllMultiQueryLiveData3957Request,
  InnerAllMultiQueryLiveData3957Response
>(innerAllMultiQueryLiveData3957RequestConfig);
export const useInnerAllMultiQueryLiveData3957 = makeRequestHook<
  InnerAllMultiQueryLiveData3957Request,
  InnerAllMultiQueryLiveData3957RequestConfig,
  ReturnType<typeof innerAllMultiQueryLiveData3957>
>(innerAllMultiQueryLiveData3957);

export interface InnerOfflineMultiQueryAuthorSalary3957Request {
  /**
   * 12324355
   */
  seqId: number;
  from: string;
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-03-10"
   */
  endTime: string;
  /**
   * [100989,200989]
   */
  anchorUidList: number[];
  /**
   * 1690424937
   */
  timestamp: number;
  /**
   * "1855d2e190de5040d0b21cd8c48f486bc14c56440934785628b5407931600203"
   */
  sign: string;
  /**
   * 2
   */
  dataType: number;
}

export interface InnerOfflineMultiQueryAuthorSalary3957Response {
  seqId: number;
  userLiveDataMapPerDay: {
    '500140021': {
      '2024-09-20': {
        bean: number;
        liveTime: number;
        fans: number;
        liveDay: number;
        noHangStime: number;
        voiceRoomAnchorBeans: number;
        voiceRoomAnchorStime: number;
        voiceRoomAnchorSday: number;
        voiceRoomTotalBeans: number;
      };
      '2024-09-21': {
        bean: number;
        liveTime: number;
        fans: number;
        liveDay: number;
        noHangStime: number;
      };
    };
    '500140022': {
      '2024-09-20': {
        bean: number;
        liveTime: number;
        fans: number;
        liveDay: number;
      };
      '2024-09-21': {
        bean: number;
        liveTime: number;
        fans: number;
        liveDay: number;
      };
    };
  };
}
type InnerOfflineMultiQueryAuthorSalary3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/offline/multiQueryAuthorSalary',
    'data',
    string,
    string,
    false
  >
>;

const innerOfflineMultiQueryAuthorSalary3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/offline/multiQueryAuthorSalary',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerOfflineMultiQueryAuthorSalary3957',
};

export const innerOfflineMultiQueryAuthorSalary3957 = makeRequest<
  InnerOfflineMultiQueryAuthorSalary3957Request,
  InnerOfflineMultiQueryAuthorSalary3957Response
>(innerOfflineMultiQueryAuthorSalary3957RequestConfig);
export const useInnerOfflineMultiQueryAuthorSalary3957 = makeRequestHook<
  InnerOfflineMultiQueryAuthorSalary3957Request,
  InnerOfflineMultiQueryAuthorSalary3957RequestConfig,
  ReturnType<typeof innerOfflineMultiQueryAuthorSalary3957>
>(innerOfflineMultiQueryAuthorSalary3957);

export interface InnerAllProxyOverview3957Request {
  /**
   * 1001
   */
  proxyUid: number;
  /**
   * [1]
   */
  tabs: number[];
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-02-10"
   */
  endTime: string;
}

export interface InnerAllProxyOverview3957Response {
  tabs: {
    type: number;
    total: number;
    list:
      | []
      | [
          {
            statDay: string;
            nums: number;
          },
        ];
    dayOnDay: string;
    weekOnWeek: string;
    monthOnMonth: string;
  }[];
  areas: string[];
  startTime: string;
  endTime: string;
}
type InnerAllProxyOverview3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/all/proxy_overview',
    'data',
    string,
    string,
    false
  >
>;

const innerAllProxyOverview3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/all/proxy_overview',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerAllProxyOverview3957',
};

export const innerAllProxyOverview3957 = makeRequest<
  InnerAllProxyOverview3957Request,
  InnerAllProxyOverview3957Response
>(innerAllProxyOverview3957RequestConfig);
export const useInnerAllProxyOverview3957 = makeRequestHook<
  InnerAllProxyOverview3957Request,
  InnerAllProxyOverview3957RequestConfig,
  ReturnType<typeof innerAllProxyOverview3957>
>(innerAllProxyOverview3957);

export interface InnerAllGetUnsignedRuleAuthorData3957Request {
  /**
   * 111
   */
  uid: number;
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-02-10"
   */
  endTime: string;
}

export interface InnerAllGetUnsignedRuleAuthorData3957Response {
  liveDuration: number;
}
type InnerAllGetUnsignedRuleAuthorData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/all/getUnsignedRuleAuthorData',
    'data',
    string,
    string,
    false
  >
>;

const innerAllGetUnsignedRuleAuthorData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/all/getUnsignedRuleAuthorData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerAllGetUnsignedRuleAuthorData3957',
};

export const innerAllGetUnsignedRuleAuthorData3957 = makeRequest<
  InnerAllGetUnsignedRuleAuthorData3957Request,
  InnerAllGetUnsignedRuleAuthorData3957Response
>(innerAllGetUnsignedRuleAuthorData3957RequestConfig);
export const useInnerAllGetUnsignedRuleAuthorData3957 = makeRequestHook<
  InnerAllGetUnsignedRuleAuthorData3957Request,
  InnerAllGetUnsignedRuleAuthorData3957RequestConfig,
  ReturnType<typeof innerAllGetUnsignedRuleAuthorData3957>
>(innerAllGetUnsignedRuleAuthorData3957);

export interface InnerOfflineGetUnsignedRuleAuthorData3957Request {
  /**
   * [111,222]
   */
  uids: number[];
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-02-10"
   */
  endTime: string;
}

export interface InnerOfflineGetUnsignedRuleAuthorData3957Response {
  '111': {
    liveDuration: number;
    liveDay: number;
  };
  '222': {
    liveDuration: number;
    liveDay: number;
  };
}
type InnerOfflineGetUnsignedRuleAuthorData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/offline/getUnsignedRuleAuthorData',
    'data',
    string,
    string,
    false
  >
>;

const innerOfflineGetUnsignedRuleAuthorData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/offline/getUnsignedRuleAuthorData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerOfflineGetUnsignedRuleAuthorData3957',
};

export const innerOfflineGetUnsignedRuleAuthorData3957 = makeRequest<
  InnerOfflineGetUnsignedRuleAuthorData3957Request,
  InnerOfflineGetUnsignedRuleAuthorData3957Response
>(innerOfflineGetUnsignedRuleAuthorData3957RequestConfig);
export const useInnerOfflineGetUnsignedRuleAuthorData3957 = makeRequestHook<
  InnerOfflineGetUnsignedRuleAuthorData3957Request,
  InnerOfflineGetUnsignedRuleAuthorData3957RequestConfig,
  ReturnType<typeof innerOfflineGetUnsignedRuleAuthorData3957>
>(innerOfflineGetUnsignedRuleAuthorData3957);

export interface InnerOfflineMultiJudgeAuthorSalaryStable3957Request {
  /**
   * 12324355
   */
  seqId: number;
  from: string;
  /**
   * "2023-02-10"
   */
  startTime: string;
  /**
   * "2023-03-10"
   */
  endTime: string;
  /**
   * [100989,200989]
   */
  anchorUidList: number[];
  /**
   * 1690424937
   */
  timestamp: number;
  /**
   * "1855d2e190de5040d0b21cd8c48f486bc14c56440934785628b5407931600203"
   */
  sign: string;
  /**
   * 2
   */
  dataType: number;
}

export interface InnerOfflineMultiJudgeAuthorSalaryStable3957Response {
  seqId: number;
  stableMap: {
    '100989': {
      '2023-02-10': boolean;
      '2023-02-11': boolean;
    };
    '101989': {
      '2023-02-10': boolean;
      '2023-02-11': boolean;
    };
  };
  uid2AllDayStable: {
    '100989': boolean;
    '101989': boolean;
  };
}
type InnerOfflineMultiJudgeAuthorSalaryStable3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/offline/multiJudgeAuthorSalaryStable',
    'data',
    string,
    string,
    false
  >
>;

const innerOfflineMultiJudgeAuthorSalaryStable3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/inner/offline/multiJudgeAuthorSalaryStable',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerOfflineMultiJudgeAuthorSalaryStable3957',
};

export const innerOfflineMultiJudgeAuthorSalaryStable3957 = makeRequest<
  InnerOfflineMultiJudgeAuthorSalaryStable3957Request,
  InnerOfflineMultiJudgeAuthorSalaryStable3957Response
>(innerOfflineMultiJudgeAuthorSalaryStable3957RequestConfig);
export const useInnerOfflineMultiJudgeAuthorSalaryStable3957 = makeRequestHook<
  InnerOfflineMultiJudgeAuthorSalaryStable3957Request,
  InnerOfflineMultiJudgeAuthorSalaryStable3957RequestConfig,
  ReturnType<typeof innerOfflineMultiJudgeAuthorSalaryStable3957>
>(innerOfflineMultiJudgeAuthorSalaryStable3957);

const mockUrl_2_0_0_8 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_8 = 'data' as any;

export interface AgentOssOpenBiz3957Request {
  /**
   * 需求号id
   */
  bizId: string;
}

export type AgentOssOpenBiz3957Response = boolean;
type AgentOssOpenBiz3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/openBiz',
    'data',
    string,
    'bizId',
    false
  >
>;

const agentOssOpenBiz3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_8,
  path: '/bigo_act_livedata_api/agentOss/openBiz',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_8,
  paramNames: [],
  queryNames: ['bizId'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssOpenBiz3957',
};

export const agentOssOpenBiz3957 = makeRequest<
  AgentOssOpenBiz3957Request,
  AgentOssOpenBiz3957Response
>(agentOssOpenBiz3957RequestConfig);
export const useAgentOssOpenBiz3957 = makeRequestHook<
  AgentOssOpenBiz3957Request,
  AgentOssOpenBiz3957RequestConfig,
  ReturnType<typeof agentOssOpenBiz3957>
>(agentOssOpenBiz3957);

export interface AgentOssInvoiceList3957Request {
  proxy_uid: string;
}

export interface AgentOssInvoiceList3957Response {
  list: {
    month: string;
    invoice_list:
      | []
      | [
          {
            date: string;
            invoice_id: number;
            url: string;
            status: number;
          },
        ];
  }[];
}
type AgentOssInvoiceList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/invoiceList',
    'data',
    string,
    string,
    false
  >
>;

const agentOssInvoiceList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_8,
  path: '/bigo_act_livedata_api/agentOss/invoiceList',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssInvoiceList3957',
};

export const agentOssInvoiceList3957 = makeRequest<
  AgentOssInvoiceList3957Request,
  AgentOssInvoiceList3957Response
>(agentOssInvoiceList3957RequestConfig);
export const useAgentOssInvoiceList3957 = makeRequestHook<
  AgentOssInvoiceList3957Request,
  AgentOssInvoiceList3957RequestConfig,
  ReturnType<typeof agentOssInvoiceList3957>
>(agentOssInvoiceList3957);

export interface AgentOssSignature3957Request {
  proxy_uid: string;
  invoice_id: string;
  url: string;
}

export interface AgentOssSignature3957Response {}
type AgentOssSignature3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/signature',
    'data',
    string,
    string,
    false
  >
>;

const agentOssSignature3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_8,
  path: '/bigo_act_livedata_api/agentOss/signature',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssSignature3957',
};

export const agentOssSignature3957 = makeRequest<
  AgentOssSignature3957Request,
  AgentOssSignature3957Response
>(agentOssSignature3957RequestConfig);
export const useAgentOssSignature3957 = makeRequestHook<
  AgentOssSignature3957Request,
  AgentOssSignature3957RequestConfig,
  ReturnType<typeof agentOssSignature3957>
>(agentOssSignature3957);

const mockUrl_2_0_0_9 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_9 = 'data' as any;

export interface Act_74338GameLiveDataApply3957Request {
  name: string;
  email: string;
  game: string;
  detail: string;
  type: number;
}

export interface Act_74338GameLiveDataApply3957Response {}
type Act_74338GameLiveDataApply3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_74338/game/live/data/apply',
    'data',
    string,
    string,
    false
  >
>;

const act_74338GameLiveDataApply3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_9,
  path: '/bigo_act_livedata_api/act_74338/game/live/data/apply',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_74338GameLiveDataApply3957',
};

export const act_74338GameLiveDataApply3957 = makeRequest<
  Act_74338GameLiveDataApply3957Request,
  Act_74338GameLiveDataApply3957Response
>(act_74338GameLiveDataApply3957RequestConfig);
export const useAct_74338GameLiveDataApply3957 = makeRequestHook<
  Act_74338GameLiveDataApply3957Request,
  Act_74338GameLiveDataApply3957RequestConfig,
  ReturnType<typeof act_74338GameLiveDataApply3957>
>(act_74338GameLiveDataApply3957);

export interface Act_74338GameLiveDataUserStatus3957Request {}

export interface Act_74338GameLiveDataUserStatus3957Response {
  status: number;
  level: string;
  s_date: string;
  month: string;
}
type Act_74338GameLiveDataUserStatus3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_74338/game/live/data/userStatus',
    'data',
    string,
    string,
    true
  >
>;

const act_74338GameLiveDataUserStatus3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_9,
  path: '/bigo_act_livedata_api/act_74338/game/live/data/userStatus',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_74338GameLiveDataUserStatus3957',
};

export const act_74338GameLiveDataUserStatus3957 = makeRequest<
  Act_74338GameLiveDataUserStatus3957Request,
  Act_74338GameLiveDataUserStatus3957Response
>(act_74338GameLiveDataUserStatus3957RequestConfig);
export const useAct_74338GameLiveDataUserStatus3957 = makeRequestHook<
  Act_74338GameLiveDataUserStatus3957Request,
  Act_74338GameLiveDataUserStatus3957RequestConfig,
  ReturnType<typeof act_74338GameLiveDataUserStatus3957>
>(act_74338GameLiveDataUserStatus3957);

export interface Act_74338GameLiveDataMonthData3957Request {
  month: string;
}

export interface Act_74338GameLiveDataMonthData3957Response {
  month_list: {
    uid: string;
    date_time: string;
    pcu_num: string;
    zd_pcu_num: string;
    zd_acu: string;
    month_acu: string;
    showtime: string;
    zd_showtime: string;
    tag_showtime: string;
    zd_staytime: string;
    fans: string;
    gift: string;
    effect_rate: string;
    live_hour: string;
    effective_day: string;
    day_effect_rate: string;
    ext_1: string;
    ext_2: string;
    ext_3: string;
    __version: string;
    __deleted: string;
    hour: string;
    acu_num: string;
    watchtime: number;
    date: string;
  }[];
  total: {
    month: string;
    hour: number;
    day: number;
    apcu: number;
    totalwatchtime: number;
    aacu: number;
    rate: number;
    effectWatchtime: number;
    addBean: number;
    fans: number;
    status: number;
  };
}
type Act_74338GameLiveDataMonthData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_74338/game/live/data/monthData',
    'data',
    string,
    'month',
    false
  >
>;

const act_74338GameLiveDataMonthData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_9,
  path: '/bigo_act_livedata_api/act_74338/game/live/data/monthData',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_9,
  paramNames: [],
  queryNames: ['month'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_74338GameLiveDataMonthData3957',
};

export const act_74338GameLiveDataMonthData3957 = makeRequest<
  Act_74338GameLiveDataMonthData3957Request,
  Act_74338GameLiveDataMonthData3957Response
>(act_74338GameLiveDataMonthData3957RequestConfig);
export const useAct_74338GameLiveDataMonthData3957 = makeRequestHook<
  Act_74338GameLiveDataMonthData3957Request,
  Act_74338GameLiveDataMonthData3957RequestConfig,
  ReturnType<typeof act_74338GameLiveDataMonthData3957>
>(act_74338GameLiveDataMonthData3957);

export interface Act_74338GameLiveDataInterfaceSwitch3957Request {}

export interface Act_74338GameLiveDataInterfaceSwitch3957Response {
  openNew: boolean;
}
type Act_74338GameLiveDataInterfaceSwitch3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_74338/game/live/data/interface/switch',
    'data',
    string,
    string,
    true
  >
>;

const act_74338GameLiveDataInterfaceSwitch3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_9,
  path: '/bigo_act_livedata_api/act_74338/game/live/data/interface/switch',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_74338GameLiveDataInterfaceSwitch3957',
};

export const act_74338GameLiveDataInterfaceSwitch3957 = makeRequest<
  Act_74338GameLiveDataInterfaceSwitch3957Request,
  Act_74338GameLiveDataInterfaceSwitch3957Response
>(act_74338GameLiveDataInterfaceSwitch3957RequestConfig);
export const useAct_74338GameLiveDataInterfaceSwitch3957 = makeRequestHook<
  Act_74338GameLiveDataInterfaceSwitch3957Request,
  Act_74338GameLiveDataInterfaceSwitch3957RequestConfig,
  ReturnType<typeof act_74338GameLiveDataInterfaceSwitch3957>
>(act_74338GameLiveDataInterfaceSwitch3957);

export interface Act_74338GameLiveDataPageSwitch3957Request {}

export interface Act_74338GameLiveDataPageSwitch3957Response {
  openNew: boolean;
}
type Act_74338GameLiveDataPageSwitch3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_74338/game/live/data/page/switch',
    'data',
    string,
    string,
    true
  >
>;

const act_74338GameLiveDataPageSwitch3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_9,
  path: '/bigo_act_livedata_api/act_74338/game/live/data/page/switch',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_74338GameLiveDataPageSwitch3957',
};

export const act_74338GameLiveDataPageSwitch3957 = makeRequest<
  Act_74338GameLiveDataPageSwitch3957Request,
  Act_74338GameLiveDataPageSwitch3957Response
>(act_74338GameLiveDataPageSwitch3957RequestConfig);
export const useAct_74338GameLiveDataPageSwitch3957 = makeRequestHook<
  Act_74338GameLiveDataPageSwitch3957Request,
  Act_74338GameLiveDataPageSwitch3957RequestConfig,
  ReturnType<typeof act_74338GameLiveDataPageSwitch3957>
>(act_74338GameLiveDataPageSwitch3957);

const mockUrl_2_0_0_10 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_10 = 'data' as any;

export interface Act_74338GameLiveDataTestInsertAnchorData3957Request {
  uid: number;
  date_time: number;
  pcu_num: number;
  zd_pcu_num: number;
  zd_acu: number;
  month_acu: number;
  showtime: number;
  zd_showtime: number;
  tag_showtime: number;
  zd_staytime: number;
  fans: number;
  gift: number;
  effect_rate: number;
  live_hour: number;
  effective_day: string;
  day_effect_rate: number;
  ext_1: string;
  ext_2: string;
  ext_3: string;
}

export type Act_74338GameLiveDataTestInsertAnchorData3957Response = boolean;
type Act_74338GameLiveDataTestInsertAnchorData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_74338/game/live/data/test/insert/anchor/data',
    'data',
    string,
    string,
    false
  >
>;

const act_74338GameLiveDataTestInsertAnchorData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_10,
  path: '/bigo_act_livedata_api/act_74338/game/live/data/test/insert/anchor/data',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_74338GameLiveDataTestInsertAnchorData3957',
};

export const act_74338GameLiveDataTestInsertAnchorData3957 = makeRequest<
  Act_74338GameLiveDataTestInsertAnchorData3957Request,
  Act_74338GameLiveDataTestInsertAnchorData3957Response
>(act_74338GameLiveDataTestInsertAnchorData3957RequestConfig);
export const useAct_74338GameLiveDataTestInsertAnchorData3957 = makeRequestHook<
  Act_74338GameLiveDataTestInsertAnchorData3957Request,
  Act_74338GameLiveDataTestInsertAnchorData3957RequestConfig,
  ReturnType<typeof act_74338GameLiveDataTestInsertAnchorData3957>
>(act_74338GameLiveDataTestInsertAnchorData3957);

export interface Act_74338GameLiveDataTestGetInfo3957Request {
  dataPartition: string;
}

export interface Act_74338GameLiveDataTestGetInfo3957Response {
  uid: number;
  date_time: number;
  pcu_num: number;
  zd_pcu_num: number;
  zd_acu: number;
  month_acu: number;
  showtime: number;
  zd_showtime: number;
  tag_showtime: number;
  zd_staytime: number;
  fans: number;
  gift: number;
  effect_rate: number;
  live_hour: number;
  effective_day: string;
  day_effect_rate: number;
  ext_1: string;
  ext_2: string;
  ext_3: string;
}
type Act_74338GameLiveDataTestGetInfo3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_74338/game/live/data/test/getInfo',
    'data',
    string,
    'dataPartition',
    false
  >
>;

const act_74338GameLiveDataTestGetInfo3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_10,
  path: '/bigo_act_livedata_api/act_74338/game/live/data/test/getInfo',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_10,
  paramNames: [],
  queryNames: ['dataPartition'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_74338GameLiveDataTestGetInfo3957',
};

export const act_74338GameLiveDataTestGetInfo3957 = makeRequest<
  Act_74338GameLiveDataTestGetInfo3957Request,
  Act_74338GameLiveDataTestGetInfo3957Response
>(act_74338GameLiveDataTestGetInfo3957RequestConfig);
export const useAct_74338GameLiveDataTestGetInfo3957 = makeRequestHook<
  Act_74338GameLiveDataTestGetInfo3957Request,
  Act_74338GameLiveDataTestGetInfo3957RequestConfig,
  ReturnType<typeof act_74338GameLiveDataTestGetInfo3957>
>(act_74338GameLiveDataTestGetInfo3957);

export interface Act_74338GameLiveDataTestClearCache3957Request {
  uid: string;
  month: string;
}

export type Act_74338GameLiveDataTestClearCache3957Response = boolean;
type Act_74338GameLiveDataTestClearCache3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_74338/game/live/data/test/clear/cache',
    'data',
    string,
    'uid' | 'month',
    false
  >
>;

const act_74338GameLiveDataTestClearCache3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_10,
  path: '/bigo_act_livedata_api/act_74338/game/live/data/test/clear/cache',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_10,
  paramNames: [],
  queryNames: ['uid', 'month'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_74338GameLiveDataTestClearCache3957',
};

export const act_74338GameLiveDataTestClearCache3957 = makeRequest<
  Act_74338GameLiveDataTestClearCache3957Request,
  Act_74338GameLiveDataTestClearCache3957Response
>(act_74338GameLiveDataTestClearCache3957RequestConfig);
export const useAct_74338GameLiveDataTestClearCache3957 = makeRequestHook<
  Act_74338GameLiveDataTestClearCache3957Request,
  Act_74338GameLiveDataTestClearCache3957RequestConfig,
  ReturnType<typeof act_74338GameLiveDataTestClearCache3957>
>(act_74338GameLiveDataTestClearCache3957);

const mockUrl_2_0_0_11 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_11 = 'data' as any;

export interface Act_77307InviteGetIndex3957Request {
  /**
   * "xxx"
   */
  langCode: string;
  /**
   * "En"
   */
  countryCode: string;
}

export interface Act_77307InviteGetIndex3957Response {
  inviteeAmount: number;
  bannerUrlInfo: {
    url: string;
    jumpUrl: string;
  };
  shareInfo: {
    userInviteCode: string;
    oneLink2Short: string;
    oneLink: string;
    longUrl: string;
    oneLink2ShortByCdn: string;
    oneLinkByCdn: string;
    longUrlByCdn: string;
  };
}
type Act_77307InviteGetIndex3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_77307/invite/getIndex',
    'data',
    string,
    string,
    false
  >
>;

const act_77307InviteGetIndex3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_11,
  path: '/bigo_act_livedata_api/act_77307/invite/getIndex',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_77307InviteGetIndex3957',
};

export const act_77307InviteGetIndex3957 = makeRequest<
  Act_77307InviteGetIndex3957Request,
  Act_77307InviteGetIndex3957Response
>(act_77307InviteGetIndex3957RequestConfig);
export const useAct_77307InviteGetIndex3957 = makeRequestHook<
  Act_77307InviteGetIndex3957Request,
  Act_77307InviteGetIndex3957RequestConfig,
  ReturnType<typeof act_77307InviteGetIndex3957>
>(act_77307InviteGetIndex3957);

export interface Act_77307InviteGetSummary3957Request {
  /**
   * 1
   */
  monthType: number;
}

export interface Act_77307InviteGetSummary3957Response {
  inviteeAmount: number;
  rechargeAmount: number;
  sendGiftAmount: number;
  gameAmount: number;
}
type Act_77307InviteGetSummary3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_77307/invite/getSummary',
    'data',
    string,
    string,
    false
  >
>;

const act_77307InviteGetSummary3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_11,
  path: '/bigo_act_livedata_api/act_77307/invite/getSummary',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_77307InviteGetSummary3957',
};

export const act_77307InviteGetSummary3957 = makeRequest<
  Act_77307InviteGetSummary3957Request,
  Act_77307InviteGetSummary3957Response
>(act_77307InviteGetSummary3957RequestConfig);
export const useAct_77307InviteGetSummary3957 = makeRequestHook<
  Act_77307InviteGetSummary3957Request,
  Act_77307InviteGetSummary3957RequestConfig,
  ReturnType<typeof act_77307InviteGetSummary3957>
>(act_77307InviteGetSummary3957);

export interface Act_77307InviteGetInviteeList3957Request {
  /**
   * 1
   */
  pageId: number;
  /**
   * 1
   */
  monthType: number;
}

export interface Act_77307InviteGetInviteeList3957Response {
  list: {
    id: string;
    uid: string;
    bigoId: string;
    avatar: string;
    nickname: string;
    rechargeAmount: string;
    sendGiftAmount: string;
    gameAmount: string;
    pairTime: string;
  }[];
}
type Act_77307InviteGetInviteeList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_77307/invite/getInviteeList',
    'data',
    string,
    string,
    false
  >
>;

const act_77307InviteGetInviteeList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_11,
  path: '/bigo_act_livedata_api/act_77307/invite/getInviteeList',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_77307InviteGetInviteeList3957',
};

export const act_77307InviteGetInviteeList3957 = makeRequest<
  Act_77307InviteGetInviteeList3957Request,
  Act_77307InviteGetInviteeList3957Response
>(act_77307InviteGetInviteeList3957RequestConfig);
export const useAct_77307InviteGetInviteeList3957 = makeRequestHook<
  Act_77307InviteGetInviteeList3957Request,
  Act_77307InviteGetInviteeList3957RequestConfig,
  ReturnType<typeof act_77307InviteGetInviteeList3957>
>(act_77307InviteGetInviteeList3957);

export interface Act_77307InviteAgreeInvite3957Request {
  /**
   * "xxx"
   */
  userInviteCode: string;
  /**
   * "xxx"
   */
  securityPacket: string;
  /**
   * 1
   */
  osType: number;
}

export interface Act_77307InviteAgreeInvite3957Response {}
type Act_77307InviteAgreeInvite3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_77307/invite/agreeInvite',
    'data',
    string,
    string,
    false
  >
>;

const act_77307InviteAgreeInvite3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_11,
  path: '/bigo_act_livedata_api/act_77307/invite/agreeInvite',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_77307InviteAgreeInvite3957',
};

export const act_77307InviteAgreeInvite3957 = makeRequest<
  Act_77307InviteAgreeInvite3957Request,
  Act_77307InviteAgreeInvite3957Response
>(act_77307InviteAgreeInvite3957RequestConfig);
export const useAct_77307InviteAgreeInvite3957 = makeRequestHook<
  Act_77307InviteAgreeInvite3957Request,
  Act_77307InviteAgreeInvite3957RequestConfig,
  ReturnType<typeof act_77307InviteAgreeInvite3957>
>(act_77307InviteAgreeInvite3957);

export interface Act_77307InviteGetMyInviterUserInfo3957Request {}

export interface Act_77307InviteGetMyInviterUserInfo3957Response {
  userInfo: {
    nickName: string;
    uid: string;
    avatar: string;
    bigoId: string;
  };
  bannerUrlInfo: {
    url: string;
    jumpUrl: string;
  };
}
type Act_77307InviteGetMyInviterUserInfo3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_77307/invite/getMyInviterUserInfo',
    'data',
    string,
    string,
    true
  >
>;

const act_77307InviteGetMyInviterUserInfo3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_11,
  path: '/bigo_act_livedata_api/act_77307/invite/getMyInviterUserInfo',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_77307InviteGetMyInviterUserInfo3957',
};

export const act_77307InviteGetMyInviterUserInfo3957 = makeRequest<
  Act_77307InviteGetMyInviterUserInfo3957Request,
  Act_77307InviteGetMyInviterUserInfo3957Response
>(act_77307InviteGetMyInviterUserInfo3957RequestConfig);
export const useAct_77307InviteGetMyInviterUserInfo3957 = makeRequestHook<
  Act_77307InviteGetMyInviterUserInfo3957Request,
  Act_77307InviteGetMyInviterUserInfo3957RequestConfig,
  ReturnType<typeof act_77307InviteGetMyInviterUserInfo3957>
>(act_77307InviteGetMyInviterUserInfo3957);

export interface Act_77307InviteGetInviterUserInfoByCode3957Request {
  /**
   * "xx"
   */
  userInviteCode: string;
}

export interface Act_77307InviteGetInviterUserInfoByCode3957Response {
  userInfo: {
    nickName: string;
    uid: string;
    avatar: string;
    bigoId: string;
  };
  bannerUrlInfo: {
    url: string;
    jumpUrl: string;
  };
  oneLinkUrl: string;
}
type Act_77307InviteGetInviterUserInfoByCode3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_77307/invite/getInviterUserInfoByCode',
    'data',
    string,
    string,
    false
  >
>;

const act_77307InviteGetInviterUserInfoByCode3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_11,
  path: '/bigo_act_livedata_api/act_77307/invite/getInviterUserInfoByCode',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_77307InviteGetInviterUserInfoByCode3957',
};

export const act_77307InviteGetInviterUserInfoByCode3957 = makeRequest<
  Act_77307InviteGetInviterUserInfoByCode3957Request,
  Act_77307InviteGetInviterUserInfoByCode3957Response
>(act_77307InviteGetInviterUserInfoByCode3957RequestConfig);
export const useAct_77307InviteGetInviterUserInfoByCode3957 = makeRequestHook<
  Act_77307InviteGetInviterUserInfoByCode3957Request,
  Act_77307InviteGetInviterUserInfoByCode3957RequestConfig,
  ReturnType<typeof act_77307InviteGetInviterUserInfoByCode3957>
>(act_77307InviteGetInviterUserInfoByCode3957);

const mockUrl_2_0_0_12 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_12 = 'data' as any;

export interface Act_78062ReportProxy3957Request {
  /**
   * "2024-07-01"
   */
  startDay: string;
  /**
   * "2024-06-01"
   */
  endDay: string;
}

export interface Act_78062ReportProxy3957Response {
  startTime: string;
  endTime: string;
  detail: {
    day: string;
    list: {
      avatar: string;
      fcnt: number;
      id: string;
      nickName: string;
      nums: number;
      sbeans: number;
      sday: number;
      statDay: string;
      stime: number;
      uid: string;
      localSbeans: number;
      overseaSbeans: number;
      exchangeRate: number;
      salarySbeans: number;
      ptSalary: number;
      ptNextSalary: number;
      ptProxySalary: number;
      ptProxyNextSalary: number;
      signDate: string;
      signCountryCode: string;
      policyCode: string;
      anchorNum: number;
      newAnchorCount: number;
      activeAnchorCount: number;
      excludeOnHookLiveDay: number;
      excludeOnHookLiveDuration: number;
    }[];
  };
  previousDetail: {
    day: string;
    list: [];
  };
  isUCProxy: boolean;
  role: number;
  subRole: number;
  showColumn: string[];
  newAnchorType: number;
}
type Act_78062ReportProxy3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act_78062_report/proxy',
    'data',
    string,
    string,
    false
  >
>;

const act_78062ReportProxy3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_12,
  path: '/bigo_act_livedata_api/act_78062_report/proxy',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act_78062ReportProxy3957',
};

export const act_78062ReportProxy3957 = makeRequest<
  Act_78062ReportProxy3957Request,
  Act_78062ReportProxy3957Response
>(act_78062ReportProxy3957RequestConfig);
export const useAct_78062ReportProxy3957 = makeRequestHook<
  Act_78062ReportProxy3957Request,
  Act_78062ReportProxy3957RequestConfig,
  ReturnType<typeof act_78062ReportProxy3957>
>(act_78062ReportProxy3957);

const mockUrl_2_0_0_13 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_13 = 'data' as any;

export interface InnerAccessCanPhpAccess3957Request {
  /**
   * "act_24675_rewrite"
   */
  namespace: string;
  /**
   * "act.24675.82073.access"
   */
  key: string;
  /**
   * 9999
   */
  uid: number;
}

export interface InnerAccessCanPhpAccess3957Response {
  access: boolean;
}
type InnerAccessCanPhpAccess3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/access/canPhpAccess',
    'data',
    string,
    string,
    false
  >
>;

const innerAccessCanPhpAccess3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_13,
  path: '/bigo_act_livedata_api/inner/access/canPhpAccess',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerAccessCanPhpAccess3957',
};

export const innerAccessCanPhpAccess3957 = makeRequest<
  InnerAccessCanPhpAccess3957Request,
  InnerAccessCanPhpAccess3957Response
>(innerAccessCanPhpAccess3957RequestConfig);
export const useInnerAccessCanPhpAccess3957 = makeRequestHook<
  InnerAccessCanPhpAccess3957Request,
  InnerAccessCanPhpAccess3957RequestConfig,
  ReturnType<typeof innerAccessCanPhpAccess3957>
>(innerAccessCanPhpAccess3957);

const mockUrl_2_0_0_14 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_14 = 'data' as any;

export interface NewAnchorReport3957Request {
  /**
   * 1
   */
  step: number;
}

export interface NewAnchorReport3957Response {
  uid: number;
  baseData: {
    na_bean: {
      id: string;
      num: string;
      lastDayNum: string;
      rate: string;
    };
    na_valid_live_duration: {
      id: string;
      num: string;
      rate: string;
    };
    na_valid_live_day: {
      id: string;
      num: string;
      rate: string;
    };
    na_fans: {
      id: string;
      num: string;
      rate: string;
    };
  };
  fieldsAndDay: {
    salaryFields: string[];
  };
}
type NewAnchorReport3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/report',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorReport3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/report',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorReport3957',
};

export const newAnchorReport3957 = makeRequest<
  NewAnchorReport3957Request,
  NewAnchorReport3957Response
>(newAnchorReport3957RequestConfig);
export const useNewAnchorReport3957 = makeRequestHook<
  NewAnchorReport3957Request,
  NewAnchorReport3957RequestConfig,
  ReturnType<typeof newAnchorReport3957>
>(newAnchorReport3957);

export interface NewAnchorProxyReport3957Request {
  /**
   * 1
   */
  step: number;
  /**
   * 16000000897
   */
  anchorUid: number;
}

export interface NewAnchorProxyReport3957Response {
  uid: number;
  baseData: {
    na_bean: {
      id: string;
      num: string;
      lastDayNum: string;
      rate: string;
    };
    na_valid_live_duration: {
      id: string;
      num: string;
      rate: string;
    };
    na_valid_live_day: {
      id: string;
      num: string;
      rate: string;
    };
    na_fans: {
      id: string;
      num: string;
      rate: string;
    };
  };
  fieldsAndDay: {
    salaryFields: string[];
  };
}
type NewAnchorProxyReport3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/proxy/report',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorProxyReport3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/proxy/report',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorProxyReport3957',
};

export const newAnchorProxyReport3957 = makeRequest<
  NewAnchorProxyReport3957Request,
  NewAnchorProxyReport3957Response
>(newAnchorProxyReport3957RequestConfig);
export const useNewAnchorProxyReport3957 = makeRequestHook<
  NewAnchorProxyReport3957Request,
  NewAnchorProxyReport3957RequestConfig,
  ReturnType<typeof newAnchorProxyReport3957>
>(newAnchorProxyReport3957);

export interface NewAnchorProxySummary3957Request {
  /**
   * "12314"
   */
  queryUid: string;
  /**
   * 1
   */
  step: number;
}

export interface NewAnchorProxySummary3957Response {
  baseData: {
    na_anchor_num: {
      id: string;
      num: string;
      lastDayNum: string;
      rate: string;
    };
    na_bean: {
      id: string;
      num: string;
      lastDayNum: string;
      rate: string;
    };
    na_valid_live_duration: {
      id: string;
      num: string;
      lastDayNum: string;
      rate: string;
    };
    na_valid_live_day: {
      id: string;
      num: string;
      lastDayNum: string;
      rate: string;
    };
    na_fans: {
      id: string;
      num: string;
      lastDayNum: string;
      rate: string;
    };
  };
  fieldsAndDay: {
    salaryFields: string[];
  };
}
type NewAnchorProxySummary3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/proxy/summary',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorProxySummary3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/proxy/summary',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorProxySummary3957',
};

export const newAnchorProxySummary3957 = makeRequest<
  NewAnchorProxySummary3957Request,
  NewAnchorProxySummary3957Response
>(newAnchorProxySummary3957RequestConfig);
export const useNewAnchorProxySummary3957 = makeRequestHook<
  NewAnchorProxySummary3957Request,
  NewAnchorProxySummary3957RequestConfig,
  ReturnType<typeof newAnchorProxySummary3957>
>(newAnchorProxySummary3957);

export interface NewAnchorAreaSummary3957Request {
  /**
   * "US"
   */
  area: string;
  /**
   * 1
   */
  step: number;
}

export interface NewAnchorAreaSummary3957Response {
  baseData: {
    na_anchor_num: {
      id: string;
      num: number;
      lastDayNum: number;
      rate: number;
    };
    na_bean: {
      id: string;
      num: number;
      lastDayNum: number;
      rate: number;
    };
    na_valid_live_duration: {
      id: string;
      num: number;
      lastDayNum: number;
      rate: number;
    };
    na_valid_live_day: {
      id: string;
      num: number;
      lastDayNum: number;
      rate: number;
    };
    na_fans: {
      id: string;
      num: number;
      lastDayNum: number;
      rate: number;
    };
  };
  fieldsAndDay: {
    salaryFields: string[];
  };
}
type NewAnchorAreaSummary3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/area/summary',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorAreaSummary3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/area/summary',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorAreaSummary3957',
};

export const newAnchorAreaSummary3957 = makeRequest<
  NewAnchorAreaSummary3957Request,
  NewAnchorAreaSummary3957Response
>(newAnchorAreaSummary3957RequestConfig);
export const useNewAnchorAreaSummary3957 = makeRequestHook<
  NewAnchorAreaSummary3957Request,
  NewAnchorAreaSummary3957RequestConfig,
  ReturnType<typeof newAnchorAreaSummary3957>
>(newAnchorAreaSummary3957);

export interface NewAnchorGraph3957Request {
  /**
   * 1
   */
  step: number;
  column: string;
}

export interface NewAnchorGraph3957Response {
  uid: number;
  step: number;
  list: {
    day: string;
    value: string;
  }[];
}
type NewAnchorGraph3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/graph',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorGraph3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/graph',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorGraph3957',
};

export const newAnchorGraph3957 = makeRequest<
  NewAnchorGraph3957Request,
  NewAnchorGraph3957Response
>(newAnchorGraph3957RequestConfig);
export const useNewAnchorGraph3957 = makeRequestHook<
  NewAnchorGraph3957Request,
  NewAnchorGraph3957RequestConfig,
  ReturnType<typeof newAnchorGraph3957>
>(newAnchorGraph3957);

export interface NewAnchorProxyGraph3957Request {
  /**
   * 1
   */
  step: number;
  /**
   * 1600012
   */
  anchorUid: number;
  column: string;
}

export interface NewAnchorProxyGraph3957Response {
  uid: number;
  step: number;
  list: {
    day: string;
    value: string;
  }[];
}
type NewAnchorProxyGraph3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/proxy/graph',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorProxyGraph3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/proxy/graph',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorProxyGraph3957',
};

export const newAnchorProxyGraph3957 = makeRequest<
  NewAnchorProxyGraph3957Request,
  NewAnchorProxyGraph3957Response
>(newAnchorProxyGraph3957RequestConfig);
export const useNewAnchorProxyGraph3957 = makeRequestHook<
  NewAnchorProxyGraph3957Request,
  NewAnchorProxyGraph3957RequestConfig,
  ReturnType<typeof newAnchorProxyGraph3957>
>(newAnchorProxyGraph3957);

export interface NewAnchorProxyDetails3957Request {
  /**
   * 12314
   */
  queryUid: number;
  /**
   * "1213"
   */
  searchId: string;
  /**
   * 1
   */
  step: number;
  /**
   * 1
   */
  stepStatus: number;
  /**
   * "2024-12-11"
   */
  from: string;
  /**
   * "2024-12-13"
   */
  to: string;
  page: number;
  /**
   * 20
   */
  pageSize: number;
}

export interface NewAnchorProxyDetails3957Response {
  total: number;
  detailList: {
    uid: number;
    bigoId: number;
    nickName: string;
    avatar: string;
    firstLiveDate: string;
    currentStep: number;
    stepDay: number;
    na_bean: number;
    na_valid_live_duration: number;
    na_valid_live_day: number;
    na_fans: number;
    brokerName: string;
    brokerId: number;
    stepEndDate: string;
    valid: boolean;
  }[];
  fieldsAndDay: {
    salaryFields: string[];
  };
}
type NewAnchorProxyDetails3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/proxy/details',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorProxyDetails3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/proxy/details',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorProxyDetails3957',
};

export const newAnchorProxyDetails3957 = makeRequest<
  NewAnchorProxyDetails3957Request,
  NewAnchorProxyDetails3957Response
>(newAnchorProxyDetails3957RequestConfig);
export const useNewAnchorProxyDetails3957 = makeRequestHook<
  NewAnchorProxyDetails3957Request,
  NewAnchorProxyDetails3957RequestConfig,
  ReturnType<typeof newAnchorProxyDetails3957>
>(newAnchorProxyDetails3957);

export interface NewAnchorProxyExportUrl3957Request {
  /**
   * 12314
   */
  queryUid: number;
  /**
   * "1213"
   */
  searchId: string;
  /**
   * 1
   */
  step: number;
  /**
   * 1
   */
  stepStatus: number;
  /**
   * "2024-10-01"
   */
  from: string;
  /**
   * "2024-10-01"
   */
  to: string;
}

export interface NewAnchorProxyExportUrl3957Response {
  url: string;
}
type NewAnchorProxyExportUrl3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/proxy/exportUrl',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorProxyExportUrl3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/proxy/exportUrl',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorProxyExportUrl3957',
};

export const newAnchorProxyExportUrl3957 = makeRequest<
  NewAnchorProxyExportUrl3957Request,
  NewAnchorProxyExportUrl3957Response
>(newAnchorProxyExportUrl3957RequestConfig);
export const useNewAnchorProxyExportUrl3957 = makeRequestHook<
  NewAnchorProxyExportUrl3957Request,
  NewAnchorProxyExportUrl3957RequestConfig,
  ReturnType<typeof newAnchorProxyExportUrl3957>
>(newAnchorProxyExportUrl3957);

export interface NewAnchorAreaExportUrl3957Request {
  /**
   * "1213"
   */
  searchId: string;
  /**
   * 1
   */
  step: number;
  /**
   * "US"
   */
  area: string;
  /**
   * 1
   */
  stepStatus: number;
}

export interface NewAnchorAreaExportUrl3957Response {
  url: string;
}
type NewAnchorAreaExportUrl3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/area/exportUrl',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorAreaExportUrl3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/area/exportUrl',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorAreaExportUrl3957',
};

export const newAnchorAreaExportUrl3957 = makeRequest<
  NewAnchorAreaExportUrl3957Request,
  NewAnchorAreaExportUrl3957Response
>(newAnchorAreaExportUrl3957RequestConfig);
export const useNewAnchorAreaExportUrl3957 = makeRequestHook<
  NewAnchorAreaExportUrl3957Request,
  NewAnchorAreaExportUrl3957RequestConfig,
  ReturnType<typeof newAnchorAreaExportUrl3957>
>(newAnchorAreaExportUrl3957);

export interface NewAnchorExportUrl3957Request {
  /**
   * 1
   */
  step: number;
  /**
   * 9999
   */
  anchorUid: number;
}

export interface NewAnchorExportUrl3957Response {
  url: string;
}
type NewAnchorExportUrl3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/exportUrl',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorExportUrl3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/exportUrl',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorExportUrl3957',
};

export const newAnchorExportUrl3957 = makeRequest<
  NewAnchorExportUrl3957Request,
  NewAnchorExportUrl3957Response
>(newAnchorExportUrl3957RequestConfig);
export const useNewAnchorExportUrl3957 = makeRequestHook<
  NewAnchorExportUrl3957Request,
  NewAnchorExportUrl3957RequestConfig,
  ReturnType<typeof newAnchorExportUrl3957>
>(newAnchorExportUrl3957);

export interface NewAnchorAreaDetails3957Request {
  /**
   * 12314
   */
  queryUid: number;
  /**
   * "1213"
   */
  searchId: string;
  /**
   * 1
   */
  step: number;
  /**
   * 1
   */
  stepStatus: number;
  /**
   * "US"
   */
  area: string;
  /**
   * "2024-10-01"
   */
  from: string;
  /**
   * "2024-10-01"
   */
  to: string;
  /**
   * 1
   */
  page: number;
  /**
   * 20
   */
  pageSize: number;
}

export interface NewAnchorAreaDetails3957Response {
  area: string;
  total: number;
  detailList: {
    uid: number;
    bigoId: number;
    nickName: string;
    avatar: string;
    currentStep: number;
    na_anchor_num: number;
    na_bean: number;
    na_valid_live_duration: number;
    na_valid_live_day: number;
    na_fans: number;
    valid: boolean;
  }[];
  fieldsAndDay: {
    salaryFields: string[];
  };
}
type NewAnchorAreaDetails3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/new_anchor/area/details',
    'data',
    string,
    string,
    false
  >
>;

const newAnchorAreaDetails3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/new_anchor/area/details',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'newAnchorAreaDetails3957',
};

export const newAnchorAreaDetails3957 = makeRequest<
  NewAnchorAreaDetails3957Request,
  NewAnchorAreaDetails3957Response
>(newAnchorAreaDetails3957RequestConfig);
export const useNewAnchorAreaDetails3957 = makeRequestHook<
  NewAnchorAreaDetails3957Request,
  NewAnchorAreaDetails3957RequestConfig,
  ReturnType<typeof newAnchorAreaDetails3957>
>(newAnchorAreaDetails3957);

export interface InnerNewAnchorIndex3957Request {
  from: string;
  /**
   * 99
   */
  timestamp: number;
  /**
   * "aa"
   */
  sign: string;
  /**
   * 111
   */
  uid: number;
}

export interface InnerNewAnchorIndex3957Response {
  access: boolean;
  stepRangeList: {
    '1': {
      begin: string;
      end: string;
    };
    '2': {
      begin: string;
      end: string;
    };
    '3': {
      begin: string;
      end: string;
    };
  };
  signDate: string;
  liveDate: string;
  currentStep: number;
  inLastDisplayTime: boolean;
  whichDay: number;
  jetLag: number;
  finishShowDayCount: number;
}
type InnerNewAnchorIndex3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/new_anchor/index',
    'data',
    string,
    string,
    false
  >
>;

const innerNewAnchorIndex3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/inner/new_anchor/index',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerNewAnchorIndex3957',
};

export const innerNewAnchorIndex3957 = makeRequest<
  InnerNewAnchorIndex3957Request,
  InnerNewAnchorIndex3957Response
>(innerNewAnchorIndex3957RequestConfig);
export const useInnerNewAnchorIndex3957 = makeRequestHook<
  InnerNewAnchorIndex3957Request,
  InnerNewAnchorIndex3957RequestConfig,
  ReturnType<typeof innerNewAnchorIndex3957>
>(innerNewAnchorIndex3957);

export interface InnerNewAnchorList3957Request {
  /**
   * 999
   */
  seqId: number;
  from: string;
  /**
   * 99
   */
  timestamp: number;
  /**
   * "aa"
   */
  sign: string;
  /**
   * 111
   */
  uid: number;
  /**
   * "2024-11-11"
   */
  startTime: string;
  /**
   * "2024-11-11"
   */
  endTime: string;
}

export interface InnerNewAnchorList3957Response {
  seqId: number;
  details: {
    date: string;
    bean: string;
    liveTime: string;
    liveDay: string;
    fans: string;
  }[];
}
type InnerNewAnchorList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/new_anchor/list',
    'data',
    string,
    string,
    false
  >
>;

const innerNewAnchorList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/inner/new_anchor/list',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerNewAnchorList3957',
};

export const innerNewAnchorList3957 = makeRequest<
  InnerNewAnchorList3957Request,
  InnerNewAnchorList3957Response
>(innerNewAnchorList3957RequestConfig);
export const useInnerNewAnchorList3957 = makeRequestHook<
  InnerNewAnchorList3957Request,
  InnerNewAnchorList3957RequestConfig,
  ReturnType<typeof innerNewAnchorList3957>
>(innerNewAnchorList3957);

export interface InnerNewAnchorBatchGetGrades3957Request {
  /**
   * [9001,9002,9003]
   */
  uids: number[];
}

export interface InnerNewAnchorBatchGetGrades3957Response {
  '9001': {
    beginDate: string;
    endDate: string;
    grade: number;
    score: number;
    regradeStatus: number;
    lastRegradeTime: number;
  };
}
type InnerNewAnchorBatchGetGrades3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/new_anchor/batchGetGrades',
    'data',
    string,
    string,
    false
  >
>;

const innerNewAnchorBatchGetGrades3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/inner/new_anchor/batchGetGrades',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerNewAnchorBatchGetGrades3957',
};

export const innerNewAnchorBatchGetGrades3957 = makeRequest<
  InnerNewAnchorBatchGetGrades3957Request,
  InnerNewAnchorBatchGetGrades3957Response
>(innerNewAnchorBatchGetGrades3957RequestConfig);
export const useInnerNewAnchorBatchGetGrades3957 = makeRequestHook<
  InnerNewAnchorBatchGetGrades3957Request,
  InnerNewAnchorBatchGetGrades3957RequestConfig,
  ReturnType<typeof innerNewAnchorBatchGetGrades3957>
>(innerNewAnchorBatchGetGrades3957);

export interface InnerNewAnchorBatchGetOfflineData3957Request {
  /**
   * [9001,9002,9003]
   */
  uids: number[];
  /**
   * "2024-01-01"
   */
  beginDay: string;
  /**
   * "2024-01-01"
   */
  endDay: string;
}

export interface InnerNewAnchorBatchGetOfflineData3957Response {
  '9001': {
    sumOfLiveDay: number;
  };
  '9002': {
    sumOfLiveDay: number;
  };
}
type InnerNewAnchorBatchGetOfflineData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/inner/new_anchor/batchGetOfflineData',
    'data',
    string,
    string,
    false
  >
>;

const innerNewAnchorBatchGetOfflineData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_14,
  path: '/bigo_act_livedata_api/inner/new_anchor/batchGetOfflineData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'innerNewAnchorBatchGetOfflineData3957',
};

export const innerNewAnchorBatchGetOfflineData3957 = makeRequest<
  InnerNewAnchorBatchGetOfflineData3957Request,
  InnerNewAnchorBatchGetOfflineData3957Response
>(innerNewAnchorBatchGetOfflineData3957RequestConfig);
export const useInnerNewAnchorBatchGetOfflineData3957 = makeRequestHook<
  InnerNewAnchorBatchGetOfflineData3957Request,
  InnerNewAnchorBatchGetOfflineData3957RequestConfig,
  ReturnType<typeof innerNewAnchorBatchGetOfflineData3957>
>(innerNewAnchorBatchGetOfflineData3957);

const mockUrl_2_0_0_15 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_15 = 'data' as any;

export interface Act67110Config3957Request {
  /**
   * 「已废弃」
   */
  anchorUid: number;
  anchorBigoId: string;
}

export interface Act67110Config3957Response {}
type Act67110Config3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/config',
    'data',
    string,
    string,
    false
  >
>;

const act67110Config3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/config',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110Config3957',
};

export const act67110Config3957 = makeRequest<
  Act67110Config3957Request,
  Act67110Config3957Response
>(act67110Config3957RequestConfig);
export const useAct67110Config3957 = makeRequestHook<
  Act67110Config3957Request,
  Act67110Config3957RequestConfig,
  ReturnType<typeof act67110Config3957>
>(act67110Config3957);

export interface Act67110GraphData3957Request {
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 结束日期，统计类型为月份时可不传
   */
  to: string;
  /**
   * 查询类型，'sbean', 'sday', 'stime', 'sfans','pcu', 'acu', 'support_percent', 'out_region_percent','onelink'
   */
  type: string;
  /**
   * 统计类型
   */
  month: string;
  /**
   * 是否为周数据，1为是，0为否
   */
  week: number;
  /**
   * 代理端请求主播数据
   * 「已废弃」
   */
  anchorUid: number;
  /**
   * 代理端请求主播数据-bigoId
   */
  anchorBigoId: string;
}

export interface Act67110GraphData3957Response {}
type Act67110GraphData3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/graphData',
    'data',
    string,
    string,
    false
  >
>;

const act67110GraphData3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/graphData',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110GraphData3957',
};

export const act67110GraphData3957 = makeRequest<
  Act67110GraphData3957Request,
  Act67110GraphData3957Response
>(act67110GraphData3957RequestConfig);
export const useAct67110GraphData3957 = makeRequestHook<
  Act67110GraphData3957Request,
  Act67110GraphData3957RequestConfig,
  ReturnType<typeof act67110GraphData3957>
>(act67110GraphData3957);

export interface Act67110ReportMonth3957Request {
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  month: string;
  /**
   * 代理请求的主播uid
   * 「已废弃」
   */
  anchorUid: number;
  /**
   * 代理请求的主播bigoId
   */
  anchorBigoId: string;
}

export interface Act67110ReportMonth3957Response {}
type Act67110ReportMonth3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/reportMonth',
    'data',
    string,
    string,
    false
  >
>;

const act67110ReportMonth3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/reportMonth',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110ReportMonth3957',
};

export const act67110ReportMonth3957 = makeRequest<
  Act67110ReportMonth3957Request,
  Act67110ReportMonth3957Response
>(act67110ReportMonth3957RequestConfig);
export const useAct67110ReportMonth3957 = makeRequestHook<
  Act67110ReportMonth3957Request,
  Act67110ReportMonth3957RequestConfig,
  ReturnType<typeof act67110ReportMonth3957>
>(act67110ReportMonth3957);

export interface Act67110ReportDay3957Request {
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 结束日期，统计类型为月份时可不传
   */
  to: string;
  /**
   * 统计类型
   */
  type: string;
  /**
   * 请求的主播uid
   * 「已废弃」
   */
  anchorUid: number;
  /**
   * 代理端请求主播数据-bigoId
   */
  anchorBigoId: string;
}

export interface Act67110ReportDay3957Response {}
type Act67110ReportDay3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/reportDay',
    'data',
    string,
    string,
    false
  >
>;

const act67110ReportDay3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/reportDay',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110ReportDay3957',
};

export const act67110ReportDay3957 = makeRequest<
  Act67110ReportDay3957Request,
  Act67110ReportDay3957Response
>(act67110ReportDay3957RequestConfig);
export const useAct67110ReportDay3957 = makeRequestHook<
  Act67110ReportDay3957Request,
  Act67110ReportDay3957RequestConfig,
  ReturnType<typeof act67110ReportDay3957>
>(act67110ReportDay3957);

export interface Act67110ExportUrl3957Request {
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 结束日期，统计类型为月份时可不传
   */
  to: string;
  /**
   * 统计类型
   */
  month: string;
  /**
   * 是否为周，1为是0为否
   */
  week: number;
  appId: number;
  /**
   * 请求的主播uid
   * 「已废弃」
   */
  anchorUid: number;
  /**
   * 代理端请求主播数据-bigoId
   */
  anchorBigoId: string;
}

export interface Act67110ExportUrl3957Response {}
type Act67110ExportUrl3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/exportUrl',
    'data',
    string,
    string,
    false
  >
>;

const act67110ExportUrl3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/exportUrl',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110ExportUrl3957',
};

export const act67110ExportUrl3957 = makeRequest<
  Act67110ExportUrl3957Request,
  Act67110ExportUrl3957Response
>(act67110ExportUrl3957RequestConfig);
export const useAct67110ExportUrl3957 = makeRequestHook<
  Act67110ExportUrl3957Request,
  Act67110ExportUrl3957RequestConfig,
  ReturnType<typeof act67110ExportUrl3957>
>(act67110ExportUrl3957);

export interface Act67110MultiRoomDay3957Request {
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 结束日期，统计类型为月份时可不传
   */
  to: string;
  /**
   * 「已废弃」
   */
  anchorUid: number;
  /**
   * 代理端请求主播数据-bigoId
   */
  anchorBigoId: string;
}

export interface Act67110MultiRoomDay3957Response {}
type Act67110MultiRoomDay3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/multiRoomDay',
    'data',
    string,
    string,
    false
  >
>;

const act67110MultiRoomDay3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/multiRoomDay',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110MultiRoomDay3957',
};

export const act67110MultiRoomDay3957 = makeRequest<
  Act67110MultiRoomDay3957Request,
  Act67110MultiRoomDay3957Response
>(act67110MultiRoomDay3957RequestConfig);
export const useAct67110MultiRoomDay3957 = makeRequestHook<
  Act67110MultiRoomDay3957Request,
  Act67110MultiRoomDay3957RequestConfig,
  ReturnType<typeof act67110MultiRoomDay3957>
>(act67110MultiRoomDay3957);

export interface Act67110MultiRoomMonth3957Request {
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 「已废弃」
   */
  anchorUid: number;
  /**
   * 代理端请求主播数据-bigoId
   */
  anchorBigoId: string;
}

export interface Act67110MultiRoomMonth3957Response {}
type Act67110MultiRoomMonth3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/multiRoomMonth',
    'data',
    string,
    string,
    false
  >
>;

const act67110MultiRoomMonth3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/multiRoomMonth',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110MultiRoomMonth3957',
};

export const act67110MultiRoomMonth3957 = makeRequest<
  Act67110MultiRoomMonth3957Request,
  Act67110MultiRoomMonth3957Response
>(act67110MultiRoomMonth3957RequestConfig);
export const useAct67110MultiRoomMonth3957 = makeRequestHook<
  Act67110MultiRoomMonth3957Request,
  Act67110MultiRoomMonth3957RequestConfig,
  ReturnType<typeof act67110MultiRoomMonth3957>
>(act67110MultiRoomMonth3957);

export interface Act67110MultiRoomGraph3957Request {
  /**
   * 日期统计类型，day：按日期；month：月份
   */
  stat_type: string;
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 结束日期，统计类型为月份时可不传
   */
  to: string;
  /**
   * 「已废弃」
   */
  anchorUid: number;
  /**
   * 代理端请求主播数据-bigoId
   */
  anchorBigoId: string;
}

export interface Act67110MultiRoomGraph3957Response {}
type Act67110MultiRoomGraph3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/multiRoomGraph',
    'data',
    string,
    string,
    false
  >
>;

const act67110MultiRoomGraph3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/multiRoomGraph',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110MultiRoomGraph3957',
};

export const act67110MultiRoomGraph3957 = makeRequest<
  Act67110MultiRoomGraph3957Request,
  Act67110MultiRoomGraph3957Response
>(act67110MultiRoomGraph3957RequestConfig);
export const useAct67110MultiRoomGraph3957 = makeRequestHook<
  Act67110MultiRoomGraph3957Request,
  Act67110MultiRoomGraph3957RequestConfig,
  ReturnType<typeof act67110MultiRoomGraph3957>
>(act67110MultiRoomGraph3957);

export interface Act67110MultiRoomDetail3957Request {
  /**
   * 日期统计类型，day：按日期；month：月份
   */
  stat_type: string;
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 结束日期，统计类型为月份时可不传
   */
  to: string;
  /**
   * 页码
   */
  page: number;
  /**
   * 「已废弃」
   */
  anchorUid: number;
  /**
   * 代理端请求主播数据-bigoId
   */
  anchorBigoId: string;
  columnName: string;
}

export interface Act67110MultiRoomDetail3957Response {}
type Act67110MultiRoomDetail3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/multiRoomDetail',
    'data',
    string,
    string,
    false
  >
>;

const act67110MultiRoomDetail3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/multiRoomDetail',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110MultiRoomDetail3957',
};

export const act67110MultiRoomDetail3957 = makeRequest<
  Act67110MultiRoomDetail3957Request,
  Act67110MultiRoomDetail3957Response
>(act67110MultiRoomDetail3957RequestConfig);
export const useAct67110MultiRoomDetail3957 = makeRequestHook<
  Act67110MultiRoomDetail3957Request,
  Act67110MultiRoomDetail3957RequestConfig,
  ReturnType<typeof act67110MultiRoomDetail3957>
>(act67110MultiRoomDetail3957);

export interface Act67110MultiRoomExportUrl3957Request {
  /**
   * 日期统计类型，day：按日期；month：月份
   */
  stat_type: string;
  /**
   * 数据类型，owner：主播数据；micers：嘉宾数据明细
   */
  data_type: string;
  columnName?: string;
  uid: number;
  /**
   * 开始日期，为day时，传2020-09-08格式；为month，传月份格式
   */
  from: string;
  /**
   * 结束日期，统计类型为月份时可不传
   */
  to: string;
  appId?: number;
  /**
   * 「已废弃」
   */
  anchorUid?: number;
  /**
   * 代理端请求主播数据-bigoId
   */
  anchorBigoId?: string;
}

export interface Act67110MultiRoomExportUrl3957Response {}
type Act67110MultiRoomExportUrl3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/act67110/multiRoomExportUrl',
    'data',
    string,
    string,
    false
  >
>;

const act67110MultiRoomExportUrl3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_15,
  path: '/bigo_act_livedata_api/act67110/multiRoomExportUrl',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'act67110MultiRoomExportUrl3957',
};

export const act67110MultiRoomExportUrl3957 = makeRequest<
  Act67110MultiRoomExportUrl3957Request,
  Act67110MultiRoomExportUrl3957Response
>(act67110MultiRoomExportUrl3957RequestConfig);
export const useAct67110MultiRoomExportUrl3957 = makeRequestHook<
  Act67110MultiRoomExportUrl3957Request,
  Act67110MultiRoomExportUrl3957RequestConfig,
  ReturnType<typeof act67110MultiRoomExportUrl3957>
>(act67110MultiRoomExportUrl3957);

const mockUrl_2_0_0_16 = 'http://yapi.ppx520.com/mock/3957' as any;
const dataKey_2_0_0_16 = 'data' as any;

export interface AgentOssOverview3957Request {
  startTime: string;
  endTime: string;
  proxyUid: number;
  operateUid: number;
  brokerUid: number;
  anchorUid: number;
  tabs: string;
}

export interface AgentOssOverview3957Response {
  tabs: {
    type: number;
    total: number;
    list:
      | []
      | [
          {
            statDay: string;
            nums: number;
          },
        ];
    dayOnDay: string;
    weekOnWeek: string;
    monthOnMonth: string;
  }[];
  areas: string[];
  packGiftBeanDateDto: {
    takKey: number;
    total: number;
    list: {
      statDay: string;
      nums: number;
    }[];
  };
  startTime: string;
  endTime: string;
}
type AgentOssOverview3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/overview',
    'data',
    string,
    string,
    false
  >
>;

const agentOssOverview3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/overview',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssOverview3957',
};

export const agentOssOverview3957 = makeRequest<
  AgentOssOverview3957Request,
  AgentOssOverview3957Response
>(agentOssOverview3957RequestConfig);
export const useAgentOssOverview3957 = makeRequestHook<
  AgentOssOverview3957Request,
  AgentOssOverview3957RequestConfig,
  ReturnType<typeof agentOssOverview3957>
>(agentOssOverview3957);

export interface AgentOssProxyList3957Request {
  proxyUid?: number;
  proxyName?: string;
  page: number;
  pageSize: number;
}

export interface AgentOssProxyList3957Response {
  list: {
    uid: number;
    id: string;
    nickName: string;
    avatar: string;
  }[];
}
type AgentOssProxyList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/proxyList',
    'data',
    string,
    string,
    false
  >
>;

const agentOssProxyList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/proxyList',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssProxyList3957',
};

export const agentOssProxyList3957 = makeRequest<
  AgentOssProxyList3957Request,
  AgentOssProxyList3957Response
>(agentOssProxyList3957RequestConfig);
export const useAgentOssProxyList3957 = makeRequestHook<
  AgentOssProxyList3957Request,
  AgentOssProxyList3957RequestConfig,
  ReturnType<typeof agentOssProxyList3957>
>(agentOssProxyList3957);

export interface AgentOssAnchorList3957Request {
  anchorBigoId: string;
  proxyUid: number;
  page: number;
  pageSize: number;
}

export interface AgentOssAnchorList3957Response {
  list: {
    uid: number;
    id: string;
    nickName: string;
    avatar: string;
  }[];
}
type AgentOssAnchorList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/anchorList',
    'data',
    string,
    string,
    false
  >
>;

const agentOssAnchorList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/anchorList',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssAnchorList3957',
};

export const agentOssAnchorList3957 = makeRequest<
  AgentOssAnchorList3957Request,
  AgentOssAnchorList3957Response
>(agentOssAnchorList3957RequestConfig);
export const useAgentOssAnchorList3957 = makeRequestHook<
  AgentOssAnchorList3957Request,
  AgentOssAnchorList3957RequestConfig,
  ReturnType<typeof agentOssAnchorList3957>
>(agentOssAnchorList3957);

export interface AgentOssMultiDetail3957Request {
  startTime: string;
  endTime: string;
  queryDay: string;
  proxyUid: number;
  anchorUid: number;
  page: number;
  pageSize: number;
  queryType: number;
  timeType: number;
  sortColumn: string;
  sortType: 'asc' | 'desc';
  lastUid?: number;
}

export interface AgentOssMultiDetail3957Response {
  detail: {
    day: string;
    list:
      | []
      | [
          {
            statDay: string;
            id: string;
            area: string;
            sbeans: number;
            stime: number;
            sday: number;
            fcnt: number;
            uid: number;
            nickName: string;
            avatar: string;
            localSbeans: number;
            overseaSbeans: number;
            exchangeRate: number;
            salarySbeans: number;
            ptSalary: number;
            ptNextSalary: number;
            ptProxySalary: number;
            ptProxyNextSalary: number;
            signDate: string;
            signCountryCode: string;
            policyCode: string;
            anchorNum: number;
            isActive: number;
            activeAnchorCount: number;
            excludeOnHookLiveDay: number;
            excludeOnHookLiveDuration: number;
            out_region_percent: number;
          },
        ];
  }[];
  nextQueryDay: string;
  nextPage: number;
  startTime: string;
  endTime: string;
  showColumn: string[];
  supportSortColumns: string[];
  supportSort: boolean;
  supportSortBeginDay: string;
  supportSortDayRangeLimit: number;
  activeAnchorDef: {
    type: number;
    condition: number;
    threshold: number;
  };
}
type AgentOssMultiDetail3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/multiDetail',
    'data',
    string,
    string,
    false
  >
>;

const agentOssMultiDetail3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/multiDetail',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssMultiDetail3957',
};

export const agentOssMultiDetail3957 = makeRequest<
  AgentOssMultiDetail3957Request,
  AgentOssMultiDetail3957Response
>(agentOssMultiDetail3957RequestConfig);
export const useAgentOssMultiDetail3957 = makeRequestHook<
  AgentOssMultiDetail3957Request,
  AgentOssMultiDetail3957RequestConfig,
  ReturnType<typeof agentOssMultiDetail3957>
>(agentOssMultiDetail3957);

export interface AgentOssDetail3957Request {
  startTime?: string;
  endTime?: string;
  queryDay?: string;
  proxyUid?: number;
  anchorUid?: number;
  page?: number;
  pageSize?: number;
  tabs: number;
  queryType: number;
  lastUid?: number;
}

export interface AgentOssDetail3957Response {
  detail: {
    day: string;
    total: number;
    list:
      | []
      | [
          {
            uid: number;
            id: string;
            statDay: string;
            nums: number;
            nickName: string;
            avatar: string;
          },
        ];
  }[];
  total: number;
  nextQueryDay: string;
  nextPage: number;
  startTime: string;
  endTime: string;
}
type AgentOssDetail3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/detail',
    'data',
    string,
    string,
    false
  >
>;

const agentOssDetail3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/detail',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssDetail3957',
};

export const agentOssDetail3957 = makeRequest<
  AgentOssDetail3957Request,
  AgentOssDetail3957Response
>(agentOssDetail3957RequestConfig);
export const useAgentOssDetail3957 = makeRequestHook<
  AgentOssDetail3957Request,
  AgentOssDetail3957RequestConfig,
  ReturnType<typeof agentOssDetail3957>
>(agentOssDetail3957);

export interface AgentOssGetRole3957Request {}

export interface AgentOssGetRole3957Response {
  area: string[];
  avatar: string;
  id: string;
  nickName: string;
  role: number;
  uid: number;
  realUid: number;
}
type AgentOssGetRole3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/getRole',
    'data',
    string,
    string,
    true
  >
>;

const agentOssGetRole3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/getRole',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssGetRole3957',
};

export const agentOssGetRole3957 = makeRequest<
  AgentOssGetRole3957Request,
  AgentOssGetRole3957Response
>(agentOssGetRole3957RequestConfig);
export const useAgentOssGetRole3957 = makeRequestHook<
  AgentOssGetRole3957Request,
  AgentOssGetRole3957RequestConfig,
  ReturnType<typeof agentOssGetRole3957>
>(agentOssGetRole3957);

export interface AgentOssGetUserType3957Request {}

export type AgentOssGetUserType3957Response = number;
type AgentOssGetUserType3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/getUserType',
    'data',
    string,
    string,
    true
  >
>;

const agentOssGetUserType3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/getUserType',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssGetUserType3957',
};

export const agentOssGetUserType3957 = makeRequest<
  AgentOssGetUserType3957Request,
  AgentOssGetUserType3957Response
>(agentOssGetUserType3957RequestConfig);
export const useAgentOssGetUserType3957 = makeRequestHook<
  AgentOssGetUserType3957Request,
  AgentOssGetUserType3957RequestConfig,
  ReturnType<typeof agentOssGetUserType3957>
>(agentOssGetUserType3957);

export interface AgentOssExport3957Request {
  startTime: string;
  endTime: string;
  dataUid: number;
  tabs: number;
  dataType: number;
  timeType?: number;
  pageType?: number;
}

export type AgentOssExport3957Response = boolean;
type AgentOssExport3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/export',
    'data',
    string,
    string,
    false
  >
>;

const agentOssExport3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/export',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssExport3957',
};

export const agentOssExport3957 = makeRequest<
  AgentOssExport3957Request,
  AgentOssExport3957Response
>(agentOssExport3957RequestConfig);
export const useAgentOssExport3957 = makeRequestHook<
  AgentOssExport3957Request,
  AgentOssExport3957RequestConfig,
  ReturnType<typeof agentOssExport3957>
>(agentOssExport3957);

export interface AgentOssQueryProxyOverview3957Request {
  startTime: string;
  endTime: string;
}

export interface AgentOssQueryProxyOverview3957Response {
  liveTime: number;
  beans: number;
  packGiftBeans: number;
  anchorCnt: number;
  avatar: string;
}
type AgentOssQueryProxyOverview3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/queryProxyOverview',
    'data',
    string,
    string,
    false
  >
>;

const agentOssQueryProxyOverview3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/queryProxyOverview',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssQueryProxyOverview3957',
};

export const agentOssQueryProxyOverview3957 = makeRequest<
  AgentOssQueryProxyOverview3957Request,
  AgentOssQueryProxyOverview3957Response
>(agentOssQueryProxyOverview3957RequestConfig);
export const useAgentOssQueryProxyOverview3957 = makeRequestHook<
  AgentOssQueryProxyOverview3957Request,
  AgentOssQueryProxyOverview3957RequestConfig,
  ReturnType<typeof agentOssQueryProxyOverview3957>
>(agentOssQueryProxyOverview3957);

export interface AgentOssPkOverview3957Request {
  start_time: string;
  end_time: string;
  /**
   * @NotNull
   */
  proxy_uid: number;
  /**
   * @NotNull
   */
  broker_uid: number;
}

export interface AgentOssPkOverview3957Response {
  tabs: {
    type: number;
    total: number;
    list:
      | []
      | [
          {
            stat_day: string;
            nums: number;
          },
        ];
    day_on_day: string;
    week_on_week: string;
    month_on_month: string;
  }[];
}
type AgentOssPkOverview3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/pkOverview',
    'data',
    string,
    string,
    false
  >
>;

const agentOssPkOverview3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/pkOverview',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssPkOverview3957',
};

export const agentOssPkOverview3957 = makeRequest<
  AgentOssPkOverview3957Request,
  AgentOssPkOverview3957Response
>(agentOssPkOverview3957RequestConfig);
export const useAgentOssPkOverview3957 = makeRequestHook<
  AgentOssPkOverview3957Request,
  AgentOssPkOverview3957RequestConfig,
  ReturnType<typeof agentOssPkOverview3957>
>(agentOssPkOverview3957);

export interface AgentOssPkDetail3957Request {
  start_time: string;
  end_time: string;
  query_day: string;
  page: number;
  page_size: number;
  proxy_uid: number;
  /**
   * 经纪人uid
   */
  broker_uid: number;
  is_export: boolean;
}

export interface AgentOssPkDetail3957Response {
  detail: {
    day: string;
    list:
      | []
      | [
          {
            stat_day: string;
            id: string;
            times: number;
            nums: number;
            uid: number;
            nick_name: string;
            avatar: string;
          },
        ];
  }[];
  download_url: string;
  nextQueryDay: string;
  nextPage: number;
  start_time: string;
  end_time: string;
}
type AgentOssPkDetail3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/pkDetail',
    'data',
    string,
    string,
    false
  >
>;

const agentOssPkDetail3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/pkDetail',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssPkDetail3957',
};

export const agentOssPkDetail3957 = makeRequest<
  AgentOssPkDetail3957Request,
  AgentOssPkDetail3957Response
>(agentOssPkDetail3957RequestConfig);
export const useAgentOssPkDetail3957 = makeRequestHook<
  AgentOssPkDetail3957Request,
  AgentOssPkDetail3957RequestConfig,
  ReturnType<typeof agentOssPkDetail3957>
>(agentOssPkDetail3957);

export interface AgentOssPkDataRelease3957Request {}

export interface AgentOssPkDataRelease3957Response {
  useNewApi: boolean;
}
type AgentOssPkDataRelease3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/pkDataRelease',
    'data',
    string,
    string,
    true
  >
>;

const agentOssPkDataRelease3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/pkDataRelease',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssPkDataRelease3957',
};

export const agentOssPkDataRelease3957 = makeRequest<
  AgentOssPkDataRelease3957Request,
  AgentOssPkDataRelease3957Response
>(agentOssPkDataRelease3957RequestConfig);
export const useAgentOssPkDataRelease3957 = makeRequestHook<
  AgentOssPkDataRelease3957Request,
  AgentOssPkDataRelease3957RequestConfig,
  ReturnType<typeof agentOssPkDataRelease3957>
>(agentOssPkDataRelease3957);

export interface AgentOssSumProxy3957Request {
  startTime: string;
  endTime: string;
  queryUid?: number;
  /**
   * 房间数据类型 0：单人房、1：多人房
   */
  dataType?: number;
}

export interface AgentOssSumProxy3957Response {
  thisPeriod: {
    key: number;
  };
  lastPeriod: {
    key: number;
  };
  showColumns: string[];
}
type AgentOssSumProxy3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/sumProxy',
    'data',
    string,
    string,
    false
  >
>;

const agentOssSumProxy3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/sumProxy',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssSumProxy3957',
};

export const agentOssSumProxy3957 = makeRequest<
  AgentOssSumProxy3957Request,
  AgentOssSumProxy3957Response
>(agentOssSumProxy3957RequestConfig);
export const useAgentOssSumProxy3957 = makeRequestHook<
  AgentOssSumProxy3957Request,
  AgentOssSumProxy3957RequestConfig,
  ReturnType<typeof agentOssSumProxy3957>
>(agentOssSumProxy3957);

export interface AgentOssPkDetailExport3957Request {
  sign: string;
  start_time: string;
  end_time: string;
  proxy_uid?: string;
  brokerUid?: string;
}

export interface AgentOssPkDetailExport3957Response {}
type AgentOssPkDetailExport3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/pkDetailExport',
    'data',
    string,
    'sign' | 'start_time' | 'end_time' | 'proxy_uid' | 'brokerUid',
    false
  >
>;

const agentOssPkDetailExport3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_16,
  path: '/bigo_act_livedata_api/agentOss/pkDetailExport',
  isYapi: true,
  isC: false,
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_16,
  paramNames: [],
  queryNames: ['sign', 'start_time', 'end_time', 'proxy_uid', 'brokerUid'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssPkDetailExport3957',
};

export const agentOssPkDetailExport3957 = makeRequest<
  AgentOssPkDetailExport3957Request,
  AgentOssPkDetailExport3957Response
>(agentOssPkDetailExport3957RequestConfig);
export const useAgentOssPkDetailExport3957 = makeRequestHook<
  AgentOssPkDetailExport3957Request,
  AgentOssPkDetailExport3957RequestConfig,
  ReturnType<typeof agentOssPkDetailExport3957>
>(agentOssPkDetailExport3957);

export interface AgentOssList3957Request {
  /**
   * "@integer(1,9)"
   */
  qry_type: number;
  anchor_bigoid: string;
  broker_uid: number;
  size: number;
  qry_context: string;
  need_total_cnt: number;
  qry_sub_type: number;
  sort_key: number;
  order: number;
  qry_sub_type_ctx: string;
}

export interface AgentOssList3957Response {
  total_cnt: number;
  anchor_list: {
    uid: string;
    bigoid: string;
    name: string;
    head: string;
    broker_uid: string;
    broker_bigoid: string;
    broker_name: string;
    this_month_live_stream_duration: number;
    sixty_days_live_stream_duration: number;
    last_live_stream_time: string;
    total_fans_cnt: number;
    contract_start_time: string;
    contract_end_time: string;
    sign_type: number;
    sign_status: number;
    is_contract_renewing: number;
    qry_context: string;
    policy_id: string;
    policy_code: string;
    transfer_status: number;
    cancel_contract_status: number;
    this_month_livedata_bean: string;
    sixty_days_livedata_bean: string;
    next_contract_start_time: string;
    next_contract_end_time: string;
    to_renew: boolean;
    identity: [] | [number];
    star_level: number;
    new_anchor_day: string;
    new_anchor_day_end: string;
    star_eval_status: number;
    star_eval_entry: number;
    open_group_stream_entry: boolean;
    loss_warning_type: number;
    action_suggestion: string;
    possible_loss_beans: number;
    remaining_coop_days: number;
    potential_type: number;
    coop_days: number;
    live_status: number;
    today_live_duration: number;
  }[];
}
type AgentOssList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/list',
    'data',
    string,
    string,
    false
  >
>;

const agentOssList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/agentOss/list',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssList3957',
};

export const agentOssList3957 = makeRequest<AgentOssList3957Request, AgentOssList3957Response>(
  agentOssList3957RequestConfig,
);
export const useAgentOssList3957 = makeRequestHook<
  AgentOssList3957Request,
  AgentOssList3957RequestConfig,
  ReturnType<typeof agentOssList3957>
>(agentOssList3957);

export interface AgentOssQryAnchorList3957Request {
  /**
   * "@integer(7,9)"
   */
  qry_type: number;
  anchor_bigoid: string;
  broker_uid: number;
  size: number;
  qry_context: string;
  need_total_cnt: number;
  qry_sub_type: number;
  sort_key: number;
  order: number;
  qry_sub_type_ctx: string;
  live_status: number;
}

export interface AgentOssQryAnchorList3957Response {
  total_cnt: number;
  anchor_list: {
    uid: string;
    bigoid: string;
    name: string;
    head: string;
    broker_uid: string;
    broker_bigoid: string;
    broker_name: string;
    broker_head: string;
    this_month_live_stream_duration: number;
    sixty_days_live_stream_duration: number;
    last_live_stream_time: string;
    total_fans_cnt: number;
    contract_start_time: string;
    contract_end_time: string;
    sign_type: number;
    sign_status: number;
    is_contract_renewing: number;
    qry_context: string;
    policy_id: string;
    policy_code: string;
    transfer_status: number;
    cancel_contract_status: number;
    this_month_livedata_bean: string;
    sixty_days_livedata_bean: string;
    next_contract_start_time: string;
    next_contract_end_time: string;
    to_renew: boolean;
    identity: [] | [number];
    star_level: number;
    new_anchor_day: string;
    new_anchor_day_end: string;
    star_eval_status: number;
    star_eval_entry: number;
    open_group_stream_entry: boolean;
    loss_warning_type: number;
    action_suggestion: string;
    possible_loss_beans: number;
    remaining_coop_days: number;
    potential_type: number;
    coop_days: number;
    live_status: number;
    room_id: string;
    today_live_duration: number;
  }[];
  qry_context: string;
}
type AgentOssQryAnchorList3957RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/3957',
    '/bigo_act_livedata_api/agentOss/qryAnchorList',
    'data',
    string,
    string,
    false
  >
>;

const agentOssQryAnchorList3957RequestConfig = {
  mockUrl: mockUrl_2_0_0_7,
  path: '/bigo_act_livedata_api/agentOss/qryAnchorList',
  isYapi: true,
  isC: false,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_2_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'agentOssQryAnchorList3957',
};

export const agentOssQryAnchorList3957 = makeRequest<
  AgentOssQryAnchorList3957Request,
  AgentOssQryAnchorList3957Response
>(agentOssQryAnchorList3957RequestConfig);
export const useAgentOssQryAnchorList3957 = makeRequestHook<
  AgentOssQryAnchorList3957Request,
  AgentOssQryAnchorList3957RequestConfig,
  ReturnType<typeof agentOssQryAnchorList3957>
>(agentOssQryAnchorList3957);

/* prettier-ignore-end */
